﻿; (function () {
	window.PersonData || (window.PersonData = {});
}());
var showTabs,
	hasLifeStoryOptions,
	tabActivate,
	contentActivate,
	addPersonNewPid,
	saveEventData,
	autoCompDateDisplayed = false,
	isCreateEvent,
	doFEMLogging = false,
	$addFactModalTrigger;
/* Edit Fact Modal */
function newFactEditModal(persondata, assertionId, haslsOptions, tabactivate, contentactivate, apNewPid, seData, iscreateevent, showtabs, dofemlogging) {
	var newFactEditModalTrigger;
	if ($('.pageHeaderStory').length === 1) {
		newFactEditModalTrigger = assertionId;
	} else {
		newFactEditModalTrigger = 'fi' + assertionId;
	}
	$('<div>').modal({
		'showLoading': true,
		'useCustomPadding': true,
		'onOpen': function ($this) {
			if (typeof (persondata) == 'undefined') {
				$.modal.showLoading(false);
				$this.html(
					'<div class="ancGrid ancGridPadded">' +
					'<div class="ancCol w100">' +
					'<p>' + PersonCard.text.addPersonErrorText + '</p>' +
					'</div>' +
					'</div>'
				);
			} else {
				showTabs = showtabs;
				hasLifeStoryOptions = haslsOptions;
				tabActivate = tabactivate;
				contentActivate = contentactivate;
				addPersonNewPid = apNewPid;
				saveEventData = seData;
				isCreateEvent = iscreateevent;
				doFEMLogging = dofemlogging;
				var isValidNewAddPersonId = (typeof (addPersonNewPid) != 'undefined' && addPersonNewPid != null && addPersonNewPid.length > 0),
					dateFieldVal = '',
					placeFieldVal = '',
					descriptionFieldVal = '',
					isPrimary = false,
					eventType = '',
					newPersonPid = '';
				window.PersonData = persondata;
				PersonData.hasAddedNewSpouse = false;
				PersonData.newAddedSpouseId = '';
				if (isValidNewAddPersonId) {
					newPersonPid = addPersonNewPid;
					PersonData.hasAddedNewSpouse = true;
					PersonData.newAddedSpouseId = addPersonNewPid;
					if (typeof (saveEventData) != 'undefined' && saveEventData.length > 0) {
						/* The data coming through is json data (eventType, date, place, description) */
						var saveEventDataObj = jQuery.parseJSON(saveEventData);
						eventType = saveEventDataObj.eventType;
						dateFieldVal = saveEventDataObj.dateField;
						placeFieldVal = saveEventDataObj.placeField;
						descriptionFieldVal = saveEventDataObj.descriptionField;
						isPrimary = false;
						if (saveEventDataObj.isAddNewSpouse === 'true') {
							$('.editModalSaveButton').off('click');
							/* Reset warnings and states */
							ResetWarningsAndValues();
							FactEditModal.isAddNewSpouse = true;
						}
					}
				}
				var pid = typeof (PersonData.personId) != 'object' ? PersonData.personId : PersonData.personId.value,
					url = getPersonAjaxUrlPrefix() + '/modals/factedit/tree/' + PersonData.treeId + '/person/' + pid + '/assertionid/' + assertionId;
				$.ajax({
					type: 'GET',
					url: url,
					cache: false,
					timeout: 20000,
					data: {
						hasLifeStoryOptions: hasLifeStoryOptions,
						newPersonPid: newPersonPid,
						showTabs: showtabs,
						doFEMLogging: doFEMLogging
					},
					success: function (data) {
						$.modal.showLoading(false);
						if (data.result) {
							var size = showtabs ? 760 : 508;
							$.modal.resize(size);
							$this
								.html(data.html)
								.find('.alertNote')
								.alert(personViewModalAlertSettingsNote)
								.end()
								.find('.alertInfo')
								.alert(personViewModalAlertSettingsInfo)
								.end()
								.find('.alertSuccess')
								.alert(personViewModalAlertSettingsSuccess)
								.end()
								.find('.alert:not(.alertNote):not(.alertInfo):not(.alertSuccess)')
								.alert(personViewModalAlertSettingsWarning);
							/* Unbinding the click is essential or we can't save after warnings */
							if (!isValidNewAddPersonId && isRelationshipEventType()) {
								$('.editModalSaveButton').off('click');
							}
							var spouseCount = parseInt(FactEditModal.person.spouseCount);
							/* Handle the modal data and sections after adding a person */
							if (isValidNewAddPersonId) {
								var dateField = $('.dateField');
								if (dateField.length > 0) {
									dateField.val(dateFieldVal);
								}
								var placeField = $('.placeField');
								if (placeField.length > 0) {
									placeField.val(placeFieldVal);
								}
								var descriptionField = $('.descriptionField');
								if (descriptionField.length > 0) {
									descriptionField.val(descriptionFieldVal);
								}
								$('#individualSpouseSelect').show();
								$('#selectedSpouse-individual').removeClass('selectedPerson');
								var $indvSpouseSelect = $('.existingSpouseIndividual');
								if ($indvSpouseSelect.length > 0) {
									$indvSpouseSelect.addClass('selectedPerson');
								}
								$('#multipleSpouseSelect').hide();
								if (spouseCount > 1) {
									$('#changeSpouseButton').show().attr('onclick', 'showMultipleSpouseSelect();');
									$('#chooseOtherButton').hide();
								} else {
									$('#changeSpouseButton').hide();
									$('#chooseOtherButton').show().attr('onclick', 'showSpouseTypeAheadSection();');
								}
								/* Reset warning message */
								FactEditModal.warningMessage = '';
								FactEditModal.hasValidationWarningToSelectSpouse = false;
								FactEditModal.isAddNewSpouse = false;
							}
							/* Callouts for facts edit modal */
							if (typeof (FactEditModal) != 'undefined') {
								$('.modalEditEvent .iconRotateRight')
									.callout({
										'position': 'left',
										'classes': 'calloutGenerateNarrative',
										'content': '#generateNarrativeCalloutDomContent',
										'style': 'dark'
									});
								$this.on('click', '.removeButton', function () {
									var $removeButton = $(this);
									if (!$removeButton.data('calloutInstance')) {
										$removeButton.callout({
											'classes': 'calloutRemoveSource',
											'content': FactEditModal.callouts.removeFact,
											'position': 'top',
											'style': 'dark'
										});
										$removeButton.callout('open');
									}
								});
							}
							sortingCardOutlineHover();
							showModalAlerts(false, '#source_sortingDivBottom', '#source_sortingDivTop');
							/* Attaching Source Citations on Events */
							$.cachedScript(PersonData.animateCardUrl).done(function () {
								sortCard('#source_sortingDivBottom', '#source_sortingDivTop');
							});
							/* Init Type ahead on various fields */
							var dateField = $('#date');
							if (dateField.length > 0 &&
								typeof (PersonCard.autoCompleteDates) != "undefined" &&
								PersonCard.autoCompleteDates == true) {
								initDateAutoCompleteValidator(dateField);
							}
							var locationField = $('#location');
							if (locationField.length > 0) {
								initPlaceAutoCompleteValidator(PersonData.treeId, locationField);
							}
							/* Open on load functionality could go to a different tab */
							var openTab = 0;
							if (typeof PersonData.openOnLoadTab != 'undefined') {
								openTab = parseInt(PersonData.openOnLoadTab);
							}
							/* The tab to open to may have been changed to Media or Sources, so reset it to Fact Detail */
							PersonData.openOnLoadTab = openTab;
							/* Check which tab we activated. This will be from when we created a new event and then we show the fact edit modal, since it exists. The user could have selected a tab to create. */
							if (FactEditModal.isAddNewFact || (typeof (isCreateEvent) !== 'undefined' && isCreateEvent)) {
								if ((typeof (tabActivate) !== 'undefined' && tabActivate != null && tabActivate.length > 0) && (typeof (contentActivate) !== 'undefined' && contentActivate != null && contentActivate.length > 0)) {
									openTab = (contentActivate === 'tabContent2') ? 1 : ((contentActivate === 'tabContent3') ? 2 : 0);
									PersonData.openOnLoadTab = openTab;
									/* Update cancel button to close text */
									var cancelClose = $('.cancelClose');
									if (cancelClose.length > 0) {
										cancelClose.text(FactEditModal.text.close);
									}
									/* Establish correct links */
									setFactModalTabsClick(!FactEditModal.hasValidationError, null, true);
								} else {
									openTab = 0;
								}
							}
							/* Prefetch tabs */
							preFetchTabs();
							modalButtonClick();
							/* Initialize Tabs */
							switch (tabActivate) {
								case '0':
								case 'factEditModalEvent': /* Event edit */
									openTab = 0;
									break;
								case '1':
								case 'factEditModalAttachMedia': /* Media edit */
									openTab = 1;
									break;
								case '2':
								case 'factEditModalSourceCitations': /* Associated Source Citations */
									openTab = 2;
									break;
								case '3':
								case 'factEditModalTimelineOptions':
									openTab = 3;
									break;
							}
							/* Setup the fact modal person node in the title details */
							setupFactModalUserCard();
							/* Get already save values for fact if we had them stored from a previously modal save. This handles reopen */
							var factItem = $('#fi' + assertionId),
								modalEditEvent = $('.tabContent1');
							/* do this event details handling (like name, gender, date, place, spouse) only when loading the fact details tab (openTab === 0)  */
							if (modalEditEvent.length > 0 && openTab === 0) {
								var selectedPerson = modalEditEvent.find('.selectedPerson');
								/* We should have selectedPerson at this point, if not, then it could be from typeahead, so need to check */
								if (isRelationshipEventType() && selectedPerson.length === 0) {
									selectedPerson = modalEditEvent.find('.selectedPerson');
								}
								/* If we don't have a relationship with the event upon open, then reset the individual node that allows save */
								if (!isValidNewAddPersonId &&
									isRelationshipEventType() &&
									FactEditModal.originalSpouseId.length === 0) {
									if (selectedPerson.length > 0) {
										resetIndividualSpouseNode(selectedPerson, 0);
									}
								}
								if (FactEditModal.eventType.toLowerCase() === 'birth' ||
									FactEditModal.eventType.toLowerCase() === 'death' ||
									FactEditModal.eventType.toLowerCase() === 'name') {
									if (factItem.hasClass('preferredEvent' + FactEditModal.eventType)) {
										modalEditEvent.find('.isPrimaryCheckbox').attr('checked', true);
										modalEditEvent.find('.isPrimaryCheckbox').attr('data-original-isprimary', 'true');
										$('#preferredEventButtonLabel').show();
										if (FactEditModal.eventType.toLowerCase() !== 'name') {
											$('#factEditModalTimelineOptions').css('display', '');
										}
									} else {
										$('#preferredEventCheckbox').show();
										/* If we don't have a preferred class, then uncheck the box */
										modalEditEvent.find('.isPrimaryCheckbox').attr('checked', false);
									}
								}
								/* For Name Fact */
								retrieveStoredFactValues(factItem,
									'.givenNameStored' + assertionId,
									modalEditEvent,
									'#givenName');
								retrieveStoredFactValues(factItem, '.surnameStored' + assertionId, modalEditEvent, '#surname');
								retrieveStoredFactValues(factItem, '.suffixStored' + assertionId, modalEditEvent, '#suffix');
								var preferredStored = factItem.find('.preferredStored' + assertionId);
								if (preferredStored.length > 0) {
									if (preferredStored.val() === 'true' &&
										factItem.hasClass('preferredEvent' + FactEditModal.eventType)) {
										modalEditEvent.find('.isPrimaryCheckbox').attr('checked', true);
									} else {
										modalEditEvent.find('.isPrimaryCheckbox').attr('checked', false);
									}
								}
								/* For event */
								retrieveStoredFactValues(factItem, '.dateStored' + assertionId, modalEditEvent, '#date');
								retrieveStoredFactValues(factItem, '.placeStored' + assertionId, modalEditEvent, '#location');
								retrieveStoredFactValues(factItem,
									'.descriptionStored' + assertionId,
									modalEditEvent,
									'#description');
								var preferredEventStored = factItem.find('.preferredEventStored' + assertionId);
								if (preferredEventStored.length > 0) {
									if (preferredEventStored.val() === 'true' &&
										factItem.hasClass('preferredEvent' + FactEditModal.eventType)) {
										modalEditEvent.find('.isPrimaryCheckbox').attr('checked', true);
									} else {
										modalEditEvent.find('.isPrimaryCheckbox').attr('checked', false);
									}
								}
								/* If no spouses to select from then show the Select person from your or Add Person */
								var individualSpouseSelect = modalEditEvent.find('#individualSpouseSelect');
								if (isRelationshipEventType() &&
									(typeof (newPersonPid) == 'undefined' ||
										(typeof (newPersonPid) != 'undefined' && newPersonPid.length === 0)) &&
									FactEditModal.originalSpouseId.length === 0) {
									/* If we don't have a relationship with the event upon open, then reset the individual node that allows save */
									if (selectedPerson.length > 0) {
										resetIndividualSpouseNode(selectedPerson, 0);
									}
									modalEditEvent
										.find('.eventAreaBannerWarning')
										.alert('close');
									/* Reset warnings and states */
									ResetWarningsAndValues();
									var multipleSpouseSelect = modalEditEvent.find('#multipleSpouseSelect');
									if (spouseCount === 1) {
										individualSpouseSelect.hide();
										multipleSpouseSelect.show();
										$('#singleScenarioSpouseSelect').show();
										$('#noSpouseForEventSingle').hide();
										$('#noSpouseForEventMulti').hide();
										$('#chooseOtherButton').show().attr('onclick', 'showSpouseTypeAheadSection();');
									} else if (spouseCount > 1) {
										individualSpouseSelect.hide();
										$('#spouseText').hide();
										$('#selectSpouseForEventText').show();
										multipleSpouseSelect.show();
										$('#noSpouseForEventSingle').hide();
										$('#noSpouseForEventMulti').hide();
										$('#chooseOtherButton').show().attr('onclick', 'showSpouseTypeAheadSection();');
									} else {
										$('#chooseOtherButton').hide();
										$('.addRelationships').show();
										showSpouseTypeAheadSection();
										$('.erAddCancel').hide();
									}
									/* Set click action for the edit modal save button */
									setEditModalSaveButtonClick();
								} else if (isRelationshipEventType() &&
									typeof (newPersonPid) != 'undefined' &&
									newPersonPid.length > 0) {
									if (spouseCount === 1) {
										/* We need to set all the data for the individual */
										setIndividualSpouseData(modalEditEvent, '.singleScenarioSpouseSelect');
									}
									/* Handle showing the individual spouse */
									if (!showIndividualSpouse()) {
										return;
									}
									/* Deal with newly created person */
									individualSpouseSelect = $('.existingSpouseIndividual');
									if (individualSpouseSelect.length > 0) {
										individualSpouseSelect.addClass('selectedPerson');
									}
									if (spouseCount === 0 || spouseCount === 1) {
										$('#changeSpouseButton').hide();
										$('#chooseOtherButton').show().attr('onclick', 'showSpouseTypeAheadSection();');
									}
									/* Set click action for the edit modal save button */
									setEditModalSaveButtonClick();
								}
							}
							/* Preset display on life story */
							var displayLifeStory = $('.tabContent4').find('.displayLifestory');
							if (displayLifeStory.length > 0) {
								var displayLifeStoryVal = displayLifeStory.prop('checked');
								displayLifeStory.data('original-displaylifestory', displayLifeStoryVal.toString());
							}
							/* 
								If the event is a gender, then we only have radio buttons where one is selected by default 
								and the create button should always be enabled and the onclick actions don't need validation.
								Otherwise they do.
							*/
							if (FactEditModal.eventType === 'Gender') {
								$('.editModalSaveButton').removeAttr('disabled');
								/* Setup the click action for the tabs */
								setFactModalTabsClick(!FactEditModal.hasValidationError);
							} else if (FactEditModal.eventType === 'Name') {
								/*
									If there is a warning with the name (usually when last name different from the father's),
									then we don't want to show right when bringing up an existing edit modal.
								*/
								modalEditEvent
									.find('.eventAreaBannerWarning')
									.alert('close');
								/* Setup the click action for the tabs */
								setFactModalTabsClick(!FactEditModal.hasValidationError);
							} else { /* Setup save for new person being added */
								if ((typeof (tabActivate) != 'undefined' && tabActivate != null && tabActivate.length > 0) &&
									(typeof (contentActivate) != 'undefined' &&
										contentActivate != null &&
										contentActivate.length > 0)
								) {
									setFactModalTabsClick(!FactEditModal.hasValidationError);
								} else {
									/* Determine if the save button is enabled*/
									setButtonandBannerBasedOnValidation();
								}
							}
							/* Need to load the modal without erroring at first, unless we came back from adding a person */
							if (PersonData.openOnLoadTab != 0) {
								switch (PersonData.openOnLoadTab) {
									case 0:
										openTab = 0;
										break;
									case 1:
										openTab = 1;
										break;
									case 2:
										openTab = 2;
										break;
									case 3:
										openTab = 3;
										break;
								}
							}
							/* Initiate Tabs */
							$('#modalContainer .tabs').tabs({
								'activeIndex': openTab
							});
							setButtonBasedOnValidation();
						} else {
							$this.html(
								'<div class="ancGrid ancGridPadded">' +
								'<div class="ancCol w100">' +
								'<p>' + PersonCard.text.addPersonErrorText + '</p>' +
								'</div>' +
								'</div>'
							);
							if (typeof (data) != 'undefined' && typeof (data.statusText) != 'undefined' && window.console) {
								window.console.log(data.statusText);
							}
						}
					},
					error: function (ex) {
						$.modal.showLoading(false);
						$this.html(
							'<div class="ancGrid ancGridPadded">' +
							'<div class="ancCol w100">' +
							'<p>' + PersonCard.text.addPersonErrorText + '</p>' +
							'</div>' +
							'</div>'
						);
						if (typeof (ex) != 'undefined' && typeof (ex.statusText) != 'undefined' && window.console) {
							window.console.log(ex.statusText);
						}
					}
				});
			}
			/* Temporary (TODO: Remove when global fix is on live.) */
			if (window.navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
				$('html').addClass('iOSFix');
			}
		},
		'onClose': function () {
			/* Modal Trigger (The $trigger method having issues with our implementation.) */
			$('#' + newFactEditModalTrigger + '').focus();
			PersonData.openOnLoadTab = 0;
		}
	});
}

function sortingCardOutlineHover() {
	$('.sortingCard')
		.on('click', '.sortingIcon', function () {
			$(this).addClass('noHover');
		})
		.on('mouseenter', '.sortingIcon:not(.noHover)', function () {
			var $this = $(this),
				$sortingCard = $(this).closest('.sortingCard');
			if ($sortingCard.hasClass('card')) {
				$sortingCard.addClass('cardOutline2');
			} else {
				$sortingCard
					.find('.card')
					.addClass('cardOutline2');
			}
		})
		.on('mouseleave', '.sortingIcon:not(.noHover)', function () {
			var $this = $(this),
				$sortingCard = $(this).closest('.sortingCard');
			if ($sortingCard.hasClass('card')) {
				$sortingCard.removeClass('cardOutline2');
			} else {
				$sortingCard
					.find('.card')
					.removeClass('cardOutline2');
			}
		});
}

function femUpdateURL(history, data) {
	if (typeof (window.PersonCard) != 'undefined') {
		var newUrl = history.url.toLowerCase();
		var curTab = '/' + window.PersonCard.tabName.toLowerCase();
		var urlArray = history.url.toLowerCase().split('?', 2);
		var fIndex = urlArray[0].indexOf(curTab);
		var lIndex = urlArray[0].lastIndexOf(curTab);
		if (fIndex !== lIndex) {
			var urlSplit = newUrl.split(curTab, 2);
			newUrl = urlSplit[0] + curTab;
			/* Setup events of initial rendered component */
			if (data && data.events && window.acom && window.acom.bus) {
				for (var event in data.events) {
					window.acom.bus.on(event, data.events[event]);
					break;
				}
			}
			History.replaceState(data, htmlDecode(window.PersonCard.name) + ' - ' + window.getTabNameStringForPageTitle(window.PersonCard.tabName), newUrl);
		}
	}
}

/* Check if this is a relationship type */
function isRelationshipEventType() {
	if (typeof (FactEditModal) != 'undefined' && typeof (FactEditModal.eventType) != 'undefined') {
		FactEditModal.isRelationshipType = (FactEditModal.eventType === 'Marriage' ||
			FactEditModal.eventType === 'MarriageBann' ||
			FactEditModal.eventType === 'MarriageContract' ||
			FactEditModal.eventType === 'MarriageLicense' ||
			FactEditModal.eventType === 'MarriageSettlement' ||
			FactEditModal.eventType === 'Annulment' ||
			FactEditModal.eventType === 'Divorce' ||
			FactEditModal.eventType === 'DivorceFiled' ||
			FactEditModal.eventType === 'Engagement' ||
			FactEditModal.eventType === 'SealSpouseLDS' ||
			FactEditModal.eventType === 'NumMarriages' ||
			FactEditModal.eventType === 'Separation');
	}
	return FactEditModal.isRelationshipType;
}

/* Check if this is a value only type */
function isValueOnlyEventType() {
	if (FactEditModal.eventType === 'Afn' ||
		FactEditModal.eventType === 'Gender' ||
		FactEditModal.eventType === 'NumMarriages' ||
		FactEditModal.eventType === 'NumMarriages' ||
		FactEditModal.eventType === 'Personid' ||
		FactEditModal.eventType === 'Rin' ||
		FactEditModal.eventType === 'Ssn' ||
		FactEditModal.eventType === 'uid' ||
		FactEditModal.eventType === 'Facebookid' ||
		FactEditModal.eventType === 'Aka' ||
		FactEditModal.eventType === 'CauseOfDeath' ||
		FactEditModal.eventType === 'NameSake')
		return true;
	return false;
}

/* initialize an autocomplete validatator for the date field */
function initDateAutoCompleteValidator($field) {
	$field.autocomplete({
		'source': $.dateValidator,
		'key': 'date',
		'highlight': false,
		'disableNoResultsMessage': true,
		'jsonConversion': function (results) {
			var jsonArray = [];
			results.dates.forEach(function (date) {
				/* Ignore results where the year context may be unclear. */
				if (date.year && date.year < 100 && !date.day && !date.doubleYear) {
					return;
				}
				/* Add formatted date to results array. */
				jsonArray.push({ 'date': date.genealogical });
			});
			return jsonArray;
		},
		'onOpen': function ($resultContainer, $before, $after) {
			autoCompDateDisplayed = true;
		},
		'onClose': function ($resultContainer, $before, $after) {
			autoCompDateDisplayed = false;
			validateAndSetupDisplay($field.get(0));
		}
	});
}
/* initPlaceAutoCompleteValidator for place */
function initPlaceAutoCompleteValidator(treeId, $field) {
    var suggestPlaceSource = window.PersonCard.domain.suggestPlace + '/suggest/place?treeId=' + treeId + '&tad=none';
    if (window.PersonCard.URL.suggestPlaceUrl && window.PersonCard.URL.suggestPlaceUrl.length > 0) {
        suggestPlaceSource = window.PersonCard.URL.suggestPlaceUrl;
    }
	$field.autocomplete({
		'source': suggestPlaceSource, /* REQUIRED; The url of the data */
		'key': 'placeName', /* REQUIRED; Key for key:value pair you are searching for */
		'queryParameter': 'term', /* REQUIRED FOR SERVICE CALL; false, if none needed; otherwise string */
		'dataType': 'json', /* Type of expected response; json, jsonp or xml; defaults to json */
		'minLength': 3, /* Number of characters to use for search; minimum of 1 */
		'maxResults': 12, /* Max results shown */
		'customDisplay': function (data) {
			return { "value": data.value, "display": data.display };
		},
		'onItemSelect': function (itemData) {
			if (itemData !== '') {
				var $this = $(this);
				if (itemData.PID != '') {
					var $card = $this.closest('.card');
					$card.find('.erAddExistingData').data('itemData', itemData);
					$card.find('.erAddSave').prop('disabled', false);
				}
			}
		}, /* Callback to fire after an item is selected from dropdown */
		'onOpen': function ($resultContainer, $before, $after) {
			autoCompDateDisplayed = true;
		},
		'onClose': function ($resultContainer, $before, $after) {
			autoCompDateDisplayed = false;
			validateAndSetupDisplay($field.get(0));
		}
	});
}

/* Setup the fact modal person node in the title details */
function setupFactModalUserCard() {
	var factTitlePersonCard = $('.factTitlePersonCard');
	if (factTitlePersonCard.length > 0) {
		var userCardImgSquare = factTitlePersonCard.find('.userCardImgSquare'),
			userCardTitle = factTitlePersonCard.find('.userCardTitle'),
			userCardSubTitle = factTitlePersonCard.find('.userCardSubTitle');
		if (userCardTitle.length > 0 && userCardSubTitle.length > 0) {
			userCardImgSquare.addClass('icon' + PersonCard.gender);
			userCardTitle.html(PersonCard.name);
			if (PersonCard.lifeYearRange.length > 1 && PersonCard.lifeYearRange !== '&ndash;') {
				userCardSubTitle.text('(' + PersonCard.lifeYearRange.replace('&ndash;', '-') + ')');
			} else {
				userCardSubTitle.text('');
			}
			factTitlePersonCard.show();
		}
	}
}

/* Retrieve any saved data that was temporarily stored for retrieval when reopening the fact edit modal */
function retrieveStoredFactValues(factItem, storedAccessor, modalArea, fieldId) {
	var storedValue = factItem.find(storedAccessor);
	if (storedValue.length > 0) {
		modalArea.find(fieldId).val(storedValue.val());
	}
}

/* Handle enabling/disabling create button */
function setButtonandBannerBasedOnValidation(showBanner) {
	var dictionary = [];
	var modalEditEvent = $('.tabContent1'),
		$banner = modalEditEvent.find('.eventAreaBannerWarning');
	/* Set the button to text default and clear all banners */
	/* we do this here because this function is called directly from the onclick handlers */

	/* Now check the state if each field's data-state (0=Empty, 1=Current, 2=Valid, 3=InvalidDate 4=Invalid), and gets the data-msg if given */
	checkFieldValidation(false, showBanner, dictionary);
	/* Show error banner to enter or fix data */
	if (showBanner) {
		if (FactEditModal.hasValidationWarning || FactEditModal.hasValidationDateWarning || FactEditModal.hasValidationError || FactEditModal.hasValidationWarningToSelectSpouse) {
			displayBannerWarning($banner);
		} else {
			clearAllBanners();
		}
	}
	/* setup the button display and text */
	setButtonBasedOnValidation();
	/* setup the links*/
	setupCorrectClickActionLinks();
}

/* Display the warning banner */
function displayBannerWarning($banner) {
	if (typeof ($banner) != 'undefined' && $banner.length > 0) {
		var validationMessage = '';
		if (FactEditModal.hasValidationError) {
			if (typeof (FactEditModal.validationErrorMessage) != 'undefined' && FactEditModal.validationErrorMessage.length > 0) {
				validationMessage = FactEditModal.validationErrorMessage;
			}
		}
		else if (FactEditModal.hasValidationWarning || FactEditModal.hasValidationDateWarning) {
			if (typeof (FactEditModal.validationWarningMessage) != 'undefined' && FactEditModal.validationWarningMessage.length > 0) {
				validationMessage = FactEditModal.validationWarningMessage;
			}
			if (isRelationshipEventType() && FactEditModal.hasValidationWarningToSelectSpouse) {
				validationMessage = (validationMessage.length > 0) ? validationMessage + '  ' + FactEditModal.text.warnToSelectSpouse :
					FactEditModal.text.warnToSelectSpouse;
			}
			else if (isDatePlaceEventType()) {
				validationMessage = (FactEditModal.hasValidationDateWarning) ? (validationMessage.length > 0) ? validationMessage + '  ' + FactEditModal.text.warnStillUseItDate : FactEditModal.text.warnStillUseItDate :
					(validationMessage.length > 0) ? validationMessage + '  ' + FactEditModal.text.warnStillUseIt : FactEditModal.text.warnStillUseIt;
			}
		} else if (isRelationshipEventType() && FactEditModal.hasValidationWarningToSelectSpouse) {
			validationMessage = (validationMessage.length > 0) ? validationMessage + '  ' + FactEditModal.text.warnToSelectSpouse :
				FactEditModal.text.warnToSelectSpouse;
		} else if (FactEditModal.hasNarrativeDataWarning) {
			validationMessage = FactEditModal.text.warnNarrativeFailed;
		}
		validationMessage = (FactEditModal.isAddNewFact) ? validationMessage.replace("{createAnywayOrSaveAnyway}", FactEditModal.text.addAnyway) :
			validationMessage.replace("{createAnywayOrSaveAnyway}", FactEditModal.text.saveAnyway);

		if (validationMessage.length > 0) {
			$banner.text(validationMessage);
			$banner.alert('open');
		}
	}
}

/* Check all the validation state for all the visible fields on the modal */
function checkFieldValidation(checkChanged, showBanner, dictionary) {
	var modalEditEvent = $('.tabContent1'),
		selectedPerson = modalEditEvent.find('.selectedPerson'),
		requiredFields = 0,
		emptyRequiredFields = 0,
		fields = 0,
		emptyFields = 0,
		changed = false;
	/* Check the state if each field's data-state (0=Empty, 1=Current, 2=Valid, 3=InvalidDate 4=Invalid), and gets the data-msg if given */
	modalEditEvent.find('.factField').each(function () {
		var $field = $(this);
		var fState = $field.data('state');
		var val = $field.val();
		/* keep track of how many fields there are */
		if (!$field.hasClass('requiredField')) {
			fields++;
		} else {
			requiredFields++;
		}
		if ($field.attr('name') !== "gender") {
			if (val) {
				if (fState == "0") {
					/* if we get here the field has a value, but it is marked as empty */
					/* this can happen when we come back from selecting a new spouse, so reset the state */
					fState = validateField($field.get(0));
				}
				if (fState == "4" || fState == "3") { /* is the current state on this field Invalid or InvalidDate? */
					if (showBanner) {
						FactEditModal.validationWarningMessage = (FactEditModal.validationWarningMessage.length === 0) ? $field.data('msg') : FactEditModal.validationWarningMessage + ' ' + $field.data('msg');
						if (fState == "3") {
							FactEditModal.hasValidationDateWarning = true;
						} else if (fState == "4") {
							FactEditModal.hasValidationWarning = true;
						}
					}
				} else if (fState == "2" || fState == "1") {  /* is the current state on this field Valid or Original? */
					/* for now we are doing nothing for valid state fields */
				}
			} else {
				if ($field.hasClass('requiredField')) {
					emptyRequiredFields++;
				} else {
					emptyFields++;
				}
			}
		}
		/* if we are supposed to check if changed... check if this is a gender and/or checked */
		if (checkChanged) {
			if ($field.attr('name') !== "gender" || $field.is(':checked')) {
				var originalValue = (typeof ($field.data('original-value')) != 'undefined') ? $field.data('original-value') : "";
				var currentValue = $field.val();
				/* if the original value of the gender checkbox doesn't match the current, then the checked status changed */
				if (originalValue != currentValue) {
					changed = true;
				}
				var extra = (typeof ($field.data('extra')) != 'undefined') ? $field.data('extra') : "";
				dictionary[$field.attr('id')] = { value: currentValue, origValue: originalValue, extra: extra };
			}
		}
	});
	/* we also need to check the 'isPrimary' checkbox (if displayed) to make sure it's state hasn't changed */
	if (checkChanged) {
		var $checkBox = modalEditEvent.find('.isPrimaryCheckbox');
		if ($checkBox.length > 0) {
			if ($checkBox.is(':checked') && $checkBox.data('original-isprimary') == false) {
				changed = true;
			}
		}
	}
	/* is this a relationship type fact (marriage, divorce, etc) */
	if (isRelationshipEventType()) {
		/* if no spouse was selected */
		if (typeof (selectedPerson) == 'undefined' || selectedPerson.length === 0) {
			/* if we are to check for change and this is not a new fact, and we did have an original spouse, then we have changed */
			if (checkChanged && !FactEditModal.isAddNewFact && typeof (FactEditModal.originalSpouseId) != 'undefined' && FactEditModal.originalSpouseId.length > 0) {
				changed = true;
			} else if (showBanner) {
				FactEditModal.hasValidationWarningToSelectSpouse = true;
			}
		}
		else if (checkChanged) { /* if we are checking for change */
			/* if there was a spouse selected, but we didn't originally have a spouse, so there was a change */
			if (typeof (FactEditModal.originalSpouseId) == 'undefined' || FactEditModal.originalSpouseId.length === 0) {
				changed = true;
			} else {
				/* there was a spouse selected, now check to see if the spouse id's match */
				var sid = selectedPerson.data('assertionid');
				if (FactEditModal.originalSpouseId != sid) {
					changed = true;
				}
			}
		}
	}
	/* check for any empty required fields and/or no data in all of the other fields */
	if (emptyRequiredFields > 0 || (fields === emptyFields && fields !== 0)) {
		/* we are not going to set the message if we aren't showing the banner */
		if (showBanner && PersonData.hasEditRights) {
			FactEditModal.validationErrorMessage = getWarningMessage((requiredFields > 0 && requiredFields === emptyRequiredFields), (fields === emptyFields));
		}
		FactEditModal.hasValidationError = true;
		changed = false;
	}
	return changed;
}

/* Clear all banners to hidden state */
function clearAllBanners() {
	$('.tabContent').find('.alert:not(.alertInfo)').each(function () {
		var $this = $(this);
		if (!$this.hasClass('alertHidden')) {
			$this.alert('close');
		}
	});
}

/* Setup the correct button set based on validation */
function setButtonBasedOnValidation() {
	if (!FactEditModal.hasValidationError && (FactEditModal.hasValidationWarning || FactEditModal.hasValidationDateWarning || FactEditModal.hasValidationWarningToSelectSpouse)) {
		$('.editModalSaveButton').off('click');
		$('.editModalSaveButton').removeAttr('disabled');
		setupCreateOrSaveAnywayTextButton();
	} else {
		if (FactEditModal.hasValidationError || FactEditModal.hasNarrativeDataWarning) {
			$('.editModalSaveButton').off('click');
			$('.editModalSaveButton').attr('disabled', 'disabled');
		} else {
			$('.editModalSaveButton').removeAttr('disabled');
		}
		setupCreateOrSaveTextButton();
	}
}

/* If we need to set the Create/Save button text*/
function setupCreateOrSaveTextButton() {
	if (FactEditModal.isAddNewFact) {
		$('.editModalSaveButton').text(FactEditModal.text.create);
	} else {
		$('.editModalSaveButton').text(FactEditModal.text.saveChanges);
	}
}

/* Deal with the tab click action only on existing facts, not when creating new ones */
function setupCorrectClickActionLinks() {
	var modalEditEvent = $('.tabContent1'),
		selectedPerson = modalEditEvent.find('.selectedPerson');
	if (FactEditModal.isAddNewFact) {
		/* Allow creating an event even if it is a relationship event and there is no spouse */
		setAddNewFactCreateAction();
	} else {
		/* If we had added a new spouse */
		if (PersonData.hasAddedNewSpouse && PersonData.newAddedSpouseId.length > 0) {
			setFactModalTabsClick(!FactEditModal.hasValidationError, PersonData.newAddedSpouseId);
		} else {
			/* If we have a relationship event that doesn't have a spouse selected, 
					* then we set the save/create button to validate and show warning then the button
					* can be updated later on it's action to perform the save/create anyway
					*/
			if (isRelationshipEventType() && ((typeof (selectedPerson) == 'undefined' || (typeof (selectedPerson) != 'undefined' && selectedPerson.length === 0)))) {
				/* Reset save/create button to validate due to showing the typeahead will unset the selected spouse */
				setFactActionWithValidate();
			} else {
				setFactModalTabsClick(!FactEditModal.hasValidationError);
			}
		}
	}
}

function setFactModalTabsClick(valid, newPidVal, showBanner) {
	if (valid) {
		if (typeof (FactEditModal.buttonsBound) == 'undefined' || !FactEditModal.buttonsBound) {
			var newPid = '';
			if (typeof (newPidVal) !== 'undefined' && newPidVal != null && newPidVal.length > 0) {
				newPid = newPidVal;
			}
			/* Banner handling for the tab click */
			var clearBanners = (typeof (showBanner) !== 'undefined' && showBanner) ? 'false' : 'true';
			var showBannerVal = (typeof (showBanner) !== 'undefined' && showBanner) ? 'true' : 'false';
			/* Save button */
			$('.editModalSaveButton').attr('onclick', 'factEditModalHandleTabClick(\'editModalSaveButton\', \'' + newPid + '\', ' + clearBanners + ', ' + showBannerVal + ', true);');
			$('#factEditModalEvent').attr('onclick', 'factEditModalHandleTabClick(\'factEditModalEvent\', \'' + newPid + '\', ' + clearBanners + ', ' + showBannerVal + ', true);');
			$('#factEditModalAttachMedia').attr('onclick', 'factEditModalHandleTabClick(\'factEditModalAttachMedia\', \'' + newPid + '\', ' + clearBanners + ', ' + showBannerVal + ', true);');
			$('#factEditModalSourceCitations').attr('onclick', 'factEditModalHandleTabClick(\'factEditModalSourceCitations\', \'' + newPid + '\', ' + clearBanners + ', ' + showBannerVal + ', true);');
			$('#factEditModalTimelineOptions').attr('onclick', 'factEditModalHandleTabClick(\'factEditModalTimelineOptions\', \'' + newPid + '\', ' + clearBanners + ', ' + showBannerVal + ', true);');
			/* changeSpouse */
			var jss = 'javascript:spouseClickHandler(\'' + FactEditModal.person.spouseCount + '\', \'' + FactEditModal.assertionId + '\', \'' + newPid + '\', \'\');';
			if (FactEditModal.person.spouseCount === '1') {
				$('.chooseOtherButton').attr('onclick', jss);
			} else {
				$('.changeSpouseButton').attr('onclick', jss);
			}
			FactEditModal.buttonsBound = true;
		}
	}
}

function spouseClickHandler(count, aid, newPid, seData) {
	if (count === '1') {
		showSpouseTypeAheadSection();
	} else {
		showMultipleSpouseSelect();
	}
}

/* Save Person Narrative and Event on Story View */
function savePersonNarrativeAndEventDataModal(assertionid, newRelationshipPid, saveEventData, isSpouseDataValidate, updateModalDisplay, callback) {
	if (typeof (updateModalDisplay) !== 'undefined' && updateModalDisplay) {
		toggleAddNewFactCreateAction(false);
		/* Clear all banners before setting */
		clearAllBanners();
	}
	var modalEditEvent = $('.tabContent1'),
		modalNarrative = $('.tabContent4'),
		modalEditEventActive = modalEditEvent.hasClass('tabActive'),
		modalNarrativeActive = modalNarrative.hasClass('tabActive'),
		selectedPerson = modalEditEvent.find('.selectedPerson'),
		isCreateRelationshipEvent = false,
		eventType = window.FactEditModal.eventType,
		isPrimary = modalEditEvent.find('.isPrimaryCheckbox').prop('checked'),
		retVal = true,
		saveEventDataObj = '';
	var placeField = '', placeFieldDataExtra = '';

	/* Check if we have any changed data from the original */
	/* Now check the state if each field's data-state, and don't save if there was nothing changed */
	var dictionary = [];
	var eventChanged = (modalEditEventActive) ? checkFieldValidation(true, false, dictionary) : false;
	var narrativeChanged = false;
	var placeGpid = null;
	var titleField = (typeof (dictionary['title']) != 'undefined') ? dictionary['title'].value : '';
	var dateField = (typeof (dictionary['date']) != 'undefined') ? dictionary['date'].value : '';
	if (typeof (dictionary['location']) != 'undefined') {
		placeField = dictionary['location'].value;
		placeFieldDataExtra = dictionary['location'].extra;
	}
	var descriptionField = (typeof (dictionary['description']) != 'undefined') ? dictionary['description'].value : '';
	var genderTypeField = (typeof (dictionary['genderMale']) != 'undefined') ? "Male" : (typeof (dictionary['genderFemale']) != 'undefined') ? "Female" : "Unknown";
	if (typeof (placeFieldDataExtra) != 'undefined' && placeFieldDataExtra.length > 0) {
		$.each($.parseJSON(placeFieldDataExtra), function (key, value) {
			if (key === 'GPID') {
				placeGpid = value;
			}
		});
	}
	var valueField = (typeof (dictionary['value']) != 'undefined') ? dictionary['value'].value : '';
	var givenNameField = (typeof (dictionary['givenName']) != 'undefined') ? dictionary['givenName'].value : '';
	var surnameField = (typeof (dictionary['surname']) != 'undefined') ? dictionary['surname'].value : '';
	var suffixNameField = (typeof (dictionary['suffix']) != 'undefined') ? dictionary['suffix'].value : '';
	/* Check if we added a new relationship event - means we have a new RID and data from the create event modal */
	if (typeof (newRelationshipPid) != 'undefined' && newRelationshipPid.length > 0) {
		isCreateRelationshipEvent = true;
		if (typeof (saveEventData) != 'undefined' && saveEventData.length > 0) {
			/* The data coming through is json data (eventType, date, place, description) */
			saveEventDataObj = jQuery.parseJSON(saveEventData);
			eventType = saveEventDataObj.eventType,
				dateField = saveEventDataObj.dateField,
				placeField = saveEventDataObj.placeField,
				descriptionField = saveEventDataObj.descriptionField,
				isPrimary = false;
		}
	}
	var originalIsPrimary = modalEditEvent.find('.isPrimaryCheckbox').attr('data-original-isprimary');
	/*	Narrative Values/Fields
		(as a note, we have to use the jquery attr to get data fields versus the data function, as the data function will get the data once and then becomes immutable
		even if we update the data attribute later, the function will always get the original value it did once -- with attr we can get any newly updated data from the data attribute)
	*/
	if (modalNarrativeActive) {
		var lsTitleVal = modalNarrative.find('.lifestoryTitleField').val(),
			lsTitleValOrig = modalNarrative.find('.lifestoryTitleField').attr('data-original-lifestorytitle'),
			narrativeVal = modalNarrative.find('.narrativeField').val(),
			narrativeValOrig = modalNarrative.find('.narrativeField').attr('data-original-narrative'),
			displOnLs = modalNarrative.find('#displayLifestory').prop('checked'),
			displOnLsOrig = modalNarrative.find('#displayLifestory').attr('data-original-displaylifestory');
		/* Check to see if any of the fields have changed via user input */
		if ((typeof (lsTitleValOrig) != 'undefined' && typeof (lsTitleVal) != 'undefined' && lsTitleValOrig !== lsTitleVal) ||
			(typeof (narrativeValOrig) != 'undefined' && typeof (narrativeVal) != 'undefined' && narrativeValOrig !== narrativeVal) ||
			(typeof (displOnLsOrig) != 'undefined' && typeof (displOnLs) != 'undefined' && displOnLsOrig !== displOnLs.toString())) {
			narrativeChanged = true;
		}
	}
	var relationshipEventType = isRelationshipEventType();
	var relationshipId = (typeof (newRelationshipPid) != 'undefined' && newRelationshipPid.length > 0) ? newRelationshipPid : (typeof (selectedPerson) != 'undefined' && selectedPerson.length > 0 && typeof (selectedPerson.attr('data-assertionId')) != 'undefined' && selectedPerson.attr('data-assertionId').length > 0) ? selectedPerson.attr('data-assertionId') : '';
	/* We should have relationshipId at this point, if not, then it could be from typeahead, so need to check */
	var isFindExistingPerson = false;
	/* Validate relationship data */
	var relTypeAheadVal = 'false';
	if (modalEditEventActive) {
		if (relationshipEventType && relationshipId != null && relationshipId !== '' && FactEditModal.originalSpouseId !== relationshipId) {
			eventChanged = true;
			relTypeAheadVal = (typeof (selectedPerson) != 'undefined' && selectedPerson.length > 0 && typeof (selectedPerson.attr('data-isTypeAhead')) != 'undefined' && selectedPerson.attr('data-isTypeAhead').length > 0) ? selectedPerson.attr('data-isTypeAhead') : ((isFindExistingPerson) ? 'true' : 'false');
		}
		/*  Otherwise, if we don't have a newly selected spouse (if we add a new person for use as a spouse),
			*	Then we go ahead and compare to the original spouse to see if we force a change, 
			*	otherwise we can get into a bad state where we might not detect a change
			*/
		else if (relationshipEventType && typeof (FactEditModal.originalSpouseId) != 'undefined' && FactEditModal.originalSpouseId != null && FactEditModal.originalSpouseId.length > 0 &&
			typeof (FactEditModal.newSpouseId) != 'undefined' && FactEditModal.newSpouseId != null && FactEditModal.newSpouseId.length > 0
			&& FactEditModal.originalSpouseId !== FactEditModal.newSpouseId) {
			eventChanged = true;
			relationshipId = FactEditModal.newSpouseId;
		}
	}
	/* Set the correct value to determine if we save both narrative and event (0), event only (1), or just narrative (2) */
	var saveValue = '';
	if (!FactEditModal.hasValidationError) {
		if (eventChanged && narrativeChanged) {
			saveValue = '0';
		} else if (eventChanged) {
			saveValue = '1';
		} else if (narrativeChanged) {
			saveValue = '2';
		}
	}
	/* handle if a relationship event, checking the dates for the spouse to make sure the event gets warned on dates outside of the liferange */
	if (modalEditEventActive) {
		if ((typeof (isSpouseDataValidate) === 'undefined' || isSpouseDataValidate === true) &&
			(typeof (originalDateVal) !== 'undefined' && typeof (dateField) !== 'undefined' && originalDateVal !== dateField) &&
			!FactEditModal.hasValidationWarningAgainstSpouseData && relationshipEventType &&
			(FactEditModal.validatedAgainstSpouseData[relationshipId] === 'undefined' ||
				(FactEditModal.validatedAgainstSpouseData[relationshipId] !== 'undefined' && !FactEditModal.validatedAgainstSpouseData[relationshipId]))) {
			eventChanged = validateRelationshipEventAgainstSpouseData(selectedPerson, eventType, dateField, false);
			FactEditModal.hasValidationWarningAgainstSpouseData = !eventChanged;
			/* This is a map to keep track of who was validated. 
			* Regardless we will set this, since we came in once to validate spouse data,
			* and since the user can have the option to save anyway, we don't want to endlessly keep validating
			*/
			FactEditModal.validatedAgainstSpouseData[relationshipId] = true;
		}
	}
	/* If we have a change to the event and/or narrative then we can save off the changes */
	if (typeof (assertionid) != 'undefined' && assertionid != null && saveValue.length > 0 && (eventChanged || narrativeChanged)) {
		/* Update buttons when saving */
		handleButtonsSavingMode();
		var url = getPersonAjaxUrlPrefix() + '/tree/' + PersonCard.treeId + '/person/' + PersonCard.personId + '/assertionid/' + assertionid + '/savepersonnarrativeandeventdata';
		$.ajax({
			type: 'POST',
			url: url,
			cache: false,
			timeout: 20000,
			/* Get current values from edit fields */
			data: {
				saveContentValue: saveValue,
				/* Narrative data (curation) */
				title: lsTitleVal,
				narrative: narrativeVal,
				isHidden: !displOnLs, /* We need to set if it is hidden, which is opposite of the checked option of show on story timeline */
				isMapOn: ($('.narrativeIsMapOn').length > 0 && $('.narrativeIsMapOn').val().length > 0) ? $('.narrativeIsMapOn').val() : false,
				isImageOn: ($('.narrativeIsImageOn').length > 0 && $('.narrativeIsImageOn').val().length > 0) ? $('.narrativeIsImageOn').val() : false,
				preferredImageId: ($('.narrativePreferredImageId').length > 0 && $('.narrativePreferredImageId').val().length > 0) ? $('.narrativePreferredImageId').val() : '',
				/* Event data */
				eventId: assertionid,
				eventType: eventType,
				customEventTitle: titleField,
				date: dateField,
				place: placeField,
				placeGpid: placeGpid,
				description: (valueField != null && valueField.length > 0) ? valueField : descriptionField,
				relationshipId: relationshipId,
				relTypeAhead: relTypeAheadVal,
				isPrimary: isPrimary,
				givenName: givenNameField,
				surname: surnameField,
				suffixName: suffixNameField,
				genderType: genderTypeField
			},
			success: function (data) {
				/* Update buttons when back to normal */
				toggleAddNewFactCreateAction(true);
				handleButtonsNormalMode();
				if (data.result) {
					FactEditModal.hasValidationWarningAgainstSpouseData = false;
					var cancelClose = $('.cancelClose');
					/* We only want to deal with fields and data if an event was changed, since the POST could be for narrative or event */
					if (eventChanged) {
						/* Update cancel button to close text */
						if (cancelClose.length > 0) {
							cancelClose.text(FactEditModal.text.close);
						}
						/* If this is a relationship event, refresh the event list */
						if (isRelationshipEventType()) {
							setTimeout(function () {
								window.glue.reload();
							}, 1000);
						} else {
							/* Update the fact item in the research view list to reflect what is changed without refreshing the page */
							var factItem = $('#fi' + assertionid);
							if (eventType === 'Name') {
								/* Set original values */
								setFieldValidationValues(dictionary);
								setTimeout(function () {
									window.glue.reload();
									window.getPersonCard();
								}, 1000);
							} else if (eventType === 'Gender') {
								/* Just reload for gender to update every place that has gender based colors and icons */
								setTimeout(function () {
									window.location.reload();
								}, 1000);
							} else {
								/* Set original values */
								setFieldValidationValues(dictionary);
								setTimeout(function () {
									window.glue.reload();
									if (eventType === 'Birth' || eventType === 'Death') {
										window.getPersonCard();
									}
								}, 1000);
							}
							/* Handle showing the individual spouse */
							if (isCreateRelationshipEvent) {
								showIndividualSpouse();
							}
						}
					}
					/* Put banner up on either tab content area if autosaving from the previous tab */
					if (saveValue.length > 0) {
						/* success banner */
						var successBanner = $('.tabActive').find('.alertSuccess');
						if (successBanner.length > 0) {
							/* If we saved the event then we are on the timeline options and we show the banner there */
							switchOnSuccessBanner(successBanner);
						}
						setupCreateOrSaveTextButton();
					}
					/* Re-get the lifestory timline options data */
					if (narrativeChanged) {
						/* Update the narrative areas with changed text */
						var narrativeTextArea = $('#narrative');
						if (narrativeTextArea.length > 0) {
							narrativeTextArea.text(narrativeVal);
							narrativeTextArea.val(narrativeVal);
							/* Set a data attribute for the original value */
							narrativeTextArea.attr('data-original-narrative', narrativeVal);
						}
						var lifestoryTitle = $('.lifestoryTitleField');
						if (lifestoryTitle.length > 0) {
							lifestoryTitle.attr('value', lsTitleVal).attr('data-original-lifestorytitle', lsTitleVal);
						}
						var displayLifestory = $('#displayLifestory');
						if (displayLifestory.length > 0) {
							displayLifestory.prop('checked', displOnLs).attr('data-original-displaylifestory', (displOnLs).toString());
						}
						if (cancelClose.length > 0) {
							cancelClose.text(FactEditModal.text.close);
						}
						/* handle no narrative */
						if (narrativeVal.length === 0) {
							factEditModalTimelineOptions(PersonCard.treeId, PersonCard.personId, assertionid, false);
						}
						/* glue reload on places where changed narrative has to be reflected like lifestory */
						if ((typeof (PersonData.GlueReloadAfterNarrativeChange) != 'undefined' && PersonData.GlueReloadAfterNarrativeChange === true)) {
							setTimeout(function () {
								window.glue.reload();
							}, 1000);
						}
					}
				} else { /* if we get here we had no results come back from the save, but no error, so we need to at least set some global variables to continue */
					if (eventChanged || narrativeChanged) {
						setTimeout(function () {
							window.glue.reload();
						}, 1000);
					}
				}
				/* if we updated a relationship type event, we will want to regenerate the narrative */
				if (relationshipEventType) {
					if (relationshipId != null && relationshipId !== '') {
						FactEditModal.originalSpouseId = relationshipId;
						var selectedPerson = modalEditEvent.find('.selectedPerson');
						if (selectedPerson.length > 0) {
							selectedPerson.data('assertionid', relationshipId);
						}
						FactEditModal.newSpouseId = relationshipId;
					}
					FactEditModal.narrativeLoaded = false;
				}
				if (typeof (callback) == "function") {
					callback();
				}
			},
			error: function (xhr, ajaxOptions, thrownError) {
				throwException('status->' + xhr.status + ' thrownError->' + thrownError);
				/* Update buttons when back to normal */
				toggleAddNewFactCreateAction(true);
				handleButtonsNormalMode();
				retVal = false;
				if (typeof (callback) == "function") {
					callback();
				}
			}
		});

	} else {
		if (FactEditModal.hasValidationError) {
			setButtonandBannerBasedOnValidation(true);
			toggleAddNewFactCreateAction(true);
			retVal = false;
		} else {
			toggleAddNewFactCreateAction(true);
		}
		if (typeof (callback) == "function") {
			callback();
		}
	}
	return retVal;
}

/* handle the tab clicks in this one handler, so we can shortcut the process on error */
function factEditModalHandleTabClick(selector, newPid, clearBanners, showBannerVal, getMedia) {
	resetValidationValues();
	personAnalyticsTrackClick(selector);
	if (FactEditModal.hasValidationError) {
		return false;
	}
	switch (selector) {
		case 'editModalSaveButton': /* Save button */
			savePersonNarrativeAndEventDataModal(FactEditModal.assertionId, newPid, '', true, clearBanners);
			if (doFEMLogging === "True" && typeof (ClickTaleEvent) == "function") {
				ClickTaleEvent('FEMFactDetailsModified');
			}
			break;
		case 'factEditModalEvent': /* Event edit */
			updateTabDisplay(selector);
			savePersonNarrativeAndEventDataModal(FactEditModal.assertionId, newPid, '', true, clearBanners, function () {
				updateTabDisplay(selector);
			});
			break;
		case 'factEditModalAttachMedia': /* Media edit */
			updateTabDisplay(selector);
			savePersonNarrativeAndEventDataModal(FactEditModal.assertionId, newPid, '', false, false, function () {
				if (doFEMLogging === "True" && typeof (ClickTaleEvent) == "function") {
					ClickTaleEvent('FEMMediaTabSelected');
				}
				if (!FactEditModal.mediaLoaded && getMedia) {
					factEditModalAttachedMedia(false, false);
				}
				updateTabDisplay(selector);
			});
			break;
		case 'factEditModalSourceCitations': /* Associated Source Citations */
			updateTabDisplay(selector);
			savePersonNarrativeAndEventDataModal(FactEditModal.assertionId, newPid, '', false, false, function () {
				factEditModalSources(showBannerVal, false);
				if (doFEMLogging === "True" && typeof (ClickTaleEvent) == "function") {
					ClickTaleEvent('FEMSourcesTabSelected');
				}
				updateTabDisplay(selector);
			});
			break;
		case 'factEditModalTimelineOptions':
			updateTabDisplay(selector);
			savePersonNarrativeAndEventDataModal(FactEditModal.assertionId, newPid, '', false, false, function () {
				if (!FactEditModal.narrativeLoaded && getMedia) {
					factEditModalTimelineOptions(FactEditModal.treeId, FactEditModal.personId, FactEditModal.assertionId, false);
				}
				updateTabDisplay(selector);
			});
			break;
	}
	return true;
}

function preFetchTabs() {
	factEditModalAttachedMedia(false, true);
	factEditModalSources(false, true);
	if (typeof (FactEditModal.assertionId) != 'undefined') {
		factEditModalTimelineOptions(FactEditModal.treeId, FactEditModal.personId, FactEditModal.assertionId, true);
	}
	return;
}

/* Fact Edit Modal - Attached Media Tab */
function factEditModalAttachedMedia(hasBanner, preFetch) {
	if (!preFetch) {
		return;
	}
	var url = getPersonAjaxUrlPrefix() + '/modals/factedit/tree/' + FactEditModal.treeId + '/person/' + FactEditModal.personId + '/assertionid/' + FactEditModal.assertionId + '/attachedmedia?noRecordMedia=true';
	$.ajax({
		type: 'GET',
		url: url,
		cache: false,
		timeout: 20000,
		data: {
			eventType: FactEditModal.eventType,
			eventTitle: FactEditModal.eventTitle
		},
		success: function (data) {
			if (data.result && data.html != null && data.html.length > 0) {
				/* Set HTML */
				$('#attachedMediaListFact')
					.removeClass('loading')
					.html(data.html)
					.find('.alertNote')
					.alert(personViewModalAlertSettingsNote)
					.end()
					.find('.alertInfo')
					.alert(personViewModalAlertSettingsInfo)
					.end()
					.find('.alertSuccess')
					.alert(personViewModalAlertSettingsSuccess)
					.end()
					.find('.alert:not(.alertNote):not(.alertInfo):not(.alertSuccess)')
					.alert(personViewModalAlertSettingsWarning);
				/* Check if there was a media failure error and show the correct message */
				if ($('.sortingDivHasError').length) {
					showModalAlerts(true, '.sortingDivBottomFactMedia', '.sortingDivTopFactMedia');
				} else {
					FactEditModal.mediaLoaded = true;
					/* Initialize the media items - set up the attach/detach handling of sorting icon clicks */
					factEditModalMedia(data.attachedMediaIds, data.unAttachedMediaIds);
					sortingCardOutlineHover();
					showModalAlerts(false, '.sortingDivBottomFactMedia', '.sortingDivTopFactMedia');
					/* This is used for Attach Media on Events */
					$.cachedScript(typeof (PersonData) != 'undefined' && PersonData.animateCardUrl).done(function () {
						sortCard('.sortingDivBottomFactMedia', '.sortingDivTopFactMedia');
					});
					/* Turn on banner */
					var bannerArea = $('.tabActive').find('.alertSuccess');
					if (typeof (hasBanner) !== 'undefined' && hasBanner === 'true' && bannerArea.length > 0) {
						switchOnSuccessBanner(bannerArea);
						/* Establish correct links */
						setFactModalTabsClick(!FactEditModal.hasValidationError);
					}
				}
			} else {
				$('#attachedMediaListFact').removeClass('loading');
				showModalAlerts(true, '.sortingDivBottomFactMedia', '.sortingDivTopFactMedia');
			}
		},
		error: function () {
			$('#attachedMediaListFact').removeClass('loading');
			showModalAlerts(true, '.sortingDivBottomFactMedia', '.sortingDivTopFactMedia');
		}
	});
	resetValidationValues();
}

function resetValidationValues() {
	/* reset all the warning/errors */
	FactEditModal.hasValidationWarning = false;
	FactEditModal.hasValidationDateWarning = false;
	FactEditModal.validationWarningMessage = '';
	FactEditModal.hasValidationError = false;
	FactEditModal.validationErrorMessage = '';
	FactEditModal.hasValidationWarningToSelectSpouse = false;
	FactEditModal.hasNarrativeDataWarning = false;
}

/* Handle a change to an input field */
function validateAndSetupDisplay(element) {
	if (!autoCompDateDisplayed) {
		resetValidationValues();
		if (typeof (element) != 'undefined') {
			validateField(element);
		}
		setButtonandBannerBasedOnValidation(true);
	}
	return true;
}

/* Fact Edit Modal - Associated Media Tab */
function factEditModalMedia(attachedMediaIds, unAttachedMediaIds) {
	/* Event Media */
	if (attachedMediaIds.length > 0) {
		setupFactEditModalDetailsForMedia(attachedMediaIds, FactEditModal.assertionId);
	}
	/* Non-Associated Event Media */
	if (unAttachedMediaIds.length) {
		setupFactEditModalDetailsForMedia(unAttachedMediaIds, FactEditModal.assertionId);
	}
}

/* validateField takes either an element or a jQuery object and validates the value in the field,
	this then sets the jquery data-state (0=Empty, 1=Current, 2=Valid, 3=Invalid Date 4=Invalid), and data-msg 
	for the given element */
function validateField(el) {
	if (typeof (el) == 'undefined') { return; }
	var isjQueryObj = el instanceof jQuery;
	var $element = (isjQueryObj) ? el : $(el);
	var value = $element.val();
	if (value.length === 0) {
		$element.data('state', '0');
		$element.data('msg', '');
		return 0;
	}
	if ($element.hasClass('dateField')) {
		/* check for invalid characters in the date field */
		if (value.charAt(0) === '\\' || value.charAt(date.length - 1) === '\\') {
			$element.data('state', '3');
			var msg = FactEditModal.text.warnDateMayBeWrong + ' ' + FactEditModal.text.warnInvalidCharacterStartEndDate;
			$element.data('msg', msg);
			return 3;
		} else {
			/* check to see if they have entered the original value back in the field */
			var origVal = $element.data('original-value');
			if ((typeof (origVal) != 'undefined' && origVal === value)) {
				$element.data('state', '1');
				$element.data('msg', '');
				return 1;
			}
			/* Validate date fields */
			var eventResults = validDate(value, FactEditModal.eventType.toLowerCase(), FactEditModal.person.personBirth, FactEditModal.person.personDeath, FactEditModal.person.motherBirth, FactEditModal.person.motherDeath, FactEditModal.person.fatherBirth, FactEditModal.person.fatherDeath, false);
			var eventValidationValues = validationCheck(FactEditModal.eventType.toLowerCase(), eventResults);
			if (eventValidationValues.hasValidationWarning) {
				$element.data('state', '3');
				$element.data('msg', eventValidationValues.validationMessage);
				return 3;
			} else {
				$element.data('state', '2');
				$element.data('msg', '');
				return 2;
			}
		}
	} else if ($element.hasClass('surnameField')) {
		var surname = $element.val();
		var validationNameMessage = validateSurname(surname, FactEditModal.person.fatherSurname, FactEditModal.person.spouseSurname, FactEditModal.gender, FactEditModal.normalSurnameValidation);
		if (validationNameMessage.length > 0) {
			$element.data('state', '3');
			var msg = (FactEditModal.validationWarningMessage.length > 0) ? FactEditModal.validationWarningMessage + '  ' + validationNameMessage : validationNameMessage;
			$element.data('msg', msg);
			/* If the surname is the same as the father's surname, then we will clear any errors anyway */
			if (typeof (surname) == 'undefined' || FactEditModal.person.fatherSurname === surname) {
				/* reset validation errors */
				$element.data('state', '2');
				$element.data('msg', '');
				return 2;
			}
			return 3;
		} else {
			$element.data('state', '2');
			$element.data('msg', '');
			return 2;
		}
	} else {
		$element.data('state', '2');
		$element.data('msg', '');
		return 2;
	}
};

/* Set buttons to saving mode (disabled and the close hidden, while the save/create has a loading icon) when back from a save/create */
function handleButtonsSavingMode() {
	/* Hide the cancel button while we save the event */
	$('.editModalSaveButton')
		.addClass('loading')
		.attr('aria-busy', 'true');
	var cancelClose = $('.cancelClose');
	if (cancelClose.length > 0) {
		cancelClose.hide();
	}
}

/* Set buttons to normal mode when back from a save/create */
function handleButtonsNormalMode() {
	$('.editModalSaveButton')
		.removeAttr('aria-busy')
		.removeClass('loading');
	var cancelClose = $('.cancelClose');
	if (cancelClose.length > 0) {
		cancelClose.show();
	}
}

/* loop through the validation values given, and set the original-values so next time we will save if modified
	we have to do this, because the modal doesn't close on save */
function setFieldValidationValues(dictionary) {
	var modalEditEvent = $('.tabContent1');
	modalEditEvent.find('.factField').each(function () {
		var $field = $(this);
		if ($field.attr('name') == "gender") {
			var field = dictionary[$field.attr('id')];
			/* if we found this field in the dictionary */
			if (field != 'undefined') {
				$field.attr('checked', true);
				$field.data('state', 1);
				$field.val(field.value);
				$field.data('original-value', field.value);
			} else {
				$field.attr('checked', false);
				$field.data('state', 0);
				$field.val("");
				$field.data('original-value', "");
			}
		} else {
			var field = dictionary[$field.attr('id')];
			/* if we found this field in the dictionary */
			if (field != 'undefined') {
				/* set the state, value, original-value etc. */
				$field.data('state', (field.value.length === 0) ? 0 : 1);
				$field.val(field.value);
				$field.data('original-value', field.value);
				if (field.extra.length > 0) {
					$field.data('extra', field.extra);
				}
			} else {
				/* set the state, value, original-value etc. to empty */
				$field.data('state', 0);
				$field.val("");
				$field.data('original-value', "");
				$field.data('extra', "");
			}
		}
	});
}

/* Update the attach/detach click state for media on the fact */
function setupFactEditModalDetailsForMedia(eventMediaIds, factId) {

	/* Quick function to determine tracking id. written this way since this 
		* function does not need to live beyond setting up the click event. */
	var getTrackingId = function (isAttached) {
		return (isAttached) ? 'editFactModalRemoveMedia' : 'editFactModalAttachMedia';
	};

	/* Get the string list of fact ids */
	var mediaList = eventMediaIds.split(',');
	if (mediaList != null && mediaList.length > 0) {
		/* Iterate on each media id */
		$.each(mediaList, function (i, mediaId) {
			/* Setup the click handler. We will determine what server call to make here and let the
				* setupCardClickEvent hook everything up. */
			var selector = '#card' + mediaId;
			setupCardClickEvent(selector, getTrackingId, function (isAttached, attachDetachCallback) {
				if (isAttached) {
					detachMediaFromEvent(factId, mediaId, attachDetachCallback);
				} else {
					attachMediaToEvent(factId, mediaId, attachDetachCallback);
				}
			});
		});
	}
}

/*
	* Function that established click events for every card.
	*
	* cardId:         The id of the of the card to connect the event to.
	* getTrackingId:  function that returns the right tracking name depending on attached state.
	* makeServerCall: function that calls the correct server action depending on attached state.
	*/
function setupCardClickEvent(selector, getTrackingId, makeServerCall) {
	var $div = $(selector);
	if ($div.length > 0) {
		var $button = $div.find('button.sortingIcon');
		if ($button.length > 0) {
			$button
				.off()
				.on('click', function (e) {
					e.preventDefault();
					/* We now determine if card is attached or not AFTER we click on it. */
					var isAttached = $div.hasClass('attached');
					/* getTrackingId is a function that will return the tracking Id based on if its attached or not. */
					personAnalyticsTrackClick(getTrackingId(isAttached));
					var attachDetachCallback = function (data) {
						if (data && data.result) {
							$div.trigger('animateListItem.move');
							if ($('.pageHeader').hasClass('pageHeaderFacts')) {
								saveUIState($('.factItemSelected'));
							}
							/* Doing a glue reload will handle all of the UI changes that need to happen post attach/detach */
							window.glue.reload(function () {
								if ($('.pageHeader').hasClass('pageHeaderFacts')) {
									loadUIState('click');
								}
							});
						}
					};
					if (typeof (makeServerCall) === 'function') {
						makeServerCall(isAttached, attachDetachCallback);
					}
				});
		}
	}
}

/* Fact Edit Modal - Associated Source Citations Tab */
function factEditModalSources(hasBanner, preFetch) {
	/* Event Sources */
	var eventSourcesList = $('.eventSourcesList' + FactEditModal.assertionId);
	if (eventSourcesList.length > 0 && eventSourcesList.val() != null && eventSourcesList.val().length > 0) {
		setupFactEditModalDetailsForSource(eventSourcesList, true);
	}
	/* Non-Associated Event Sources */
	var unattachedEventSourcesList = $('.unattachedEventSourcesList' + FactEditModal.assertionId);
	if (unattachedEventSourcesList.length > 0 && unattachedEventSourcesList.val() != null && unattachedEventSourcesList.val().length > 0) {
		setupFactEditModalDetailsForSource(unattachedEventSourcesList, false);
	}
	/* Turn on banner */
	if (!preFetch) {
		var bannerArea = $('.tabActive').find('.alertSuccess');
		if (typeof (hasBanner) !== 'undefined' && hasBanner && bannerArea.length > 0) {
			switchOnSuccessBanner(bannerArea);
			/* Establish correct links */
			setFactModalTabsClick(!FactEditModal.hasValidationError);
		}
	}
}

/* Update the details for each source node on the Fact Edit Modal */
function setupFactEditModalDetailsForSource(listItem, isAttached) {

	/* Quick function to determine tracking id. written this way since this 
		* function does not need to live beyond setting up the click event. */
	var getTrackingId = function (isAttached) {
		return (isAttached) ? 'editFactModalRemoveSource' : 'editFactModalAddSource';
	};

	/* Get the string list of source ids */
	var sourcesList = listItem.val().split(',');
	if (sourcesList != null && sourcesList.length > 0) {
		/* Iterate on each source id */
		$.each(sourcesList, function (i, sourceId) {
			/* Get the source node so we can get the source image */
			var sourceItem = $('#modal_si' + sourceId);
			var userCardItem = $('.userCardsi' + sourceId);
			if (sourceItem.length > 0) {
				var dbId = sourceItem.find('.dbId').val();
				/* If it is ancestry trees source */
				if (dbId === '1030') {
					userCardItem.find('.userCardImg').addClass('icon iconAcom');
				} else {
					/* get the image from the node */
					var sourceNode = $('#si' + sourceId);
					var nodeUserCardImg = sourceNode.find('.userCardImg');
					var imgItem = nodeUserCardImg.children('img');
					if (imgItem.length > 0) {
						var imgSrc = imgItem.attr('src');
						/* Get the node from the source list modal */
						if (userCardItem.length > 0) {
							/* set the source card image */
							userCardItem.find('.userCardImg').html('<img class="" src="' + imgSrc + '" alt="" />');
							userCardItem.find('.userCardImg').attr('style', 'background-image:url(\'' + imgSrc + '\');');
							userCardItem.find('.userCardImg').addClass('userCardImgSquare userCardImgCenter');
						}
					} else { /* if it a custom or general document source */
						userCardItem.find('.userCardImg').addClass('icon iconDocument');
					}
				}

				var selector = '#modal_si' + sourceId;

				/* Setup the click handler. We will determine what server call to make here and let the
					* setupCardClickEvent hook everything up. */
				setupCardClickEvent(selector, getTrackingId, function (isAttached, attachDetachCallback) {
					if (isAttached) {
						detachSourceFromEvent(FactEditModal.assertionId, sourceId, selector, attachDetachCallback);
					} else {
						attachSourceToEvent(FactEditModal.assertionId, sourceId, selector, attachDetachCallback);
					}
				});
			}
			else {
				/* If it is ancestry trees source */
				if (sourceId === '1030') {
					userCardItem.find('.userCardImg').addClass('icon iconAcom');
				} else { /* if it a custom or general document source */
					userCardItem.find('.userCardImg').addClass('icon iconDocument');
				}
			}
		});
	}
}

/*  Edit Fact Modal - Timeline Options Tab */
function factEditModalTimelineOptions(treeId, personId, assertionId, preFetch) {
	var url = getPersonAjaxUrlPrefix() + '/modals/factedit/tree/' + treeId + '/person/' + personId + '/assertionid/' + assertionId + '/timeline';
	$.ajax({
		type: 'GET',
		url: url,
		cache: false,
		timeout: 20000,
		success: function (data) {
			var $tabContent4 = $('.tabContent4');
			var narrativeTextArea = $tabContent4.find('#narrative');
			var displayLifestory = $tabContent4.find('#displayLifestory');
			if (data.result && data.personEventNarrativeDataResponse != null) {
				/* Fill in the data field details */
				var generateNarrativeButton = $tabContent4.find('#generateNarrative');
				if (FactEditModal.showGenerateNarratives && generateNarrativeButton.length > 0 && data.personEventNarrativeDataResponse.DefaultNarrative != null && data.personEventNarrativeDataResponse.DefaultNarrative.length > 0) {
					generateNarrativeButton.show();
				}
				if (narrativeTextArea.length > 0) {
					/* did the get new narrative fail, even though we had a narrative before? */
					if (narrativeTextArea.val().length > 0 && (data.personEventNarrativeDataResponse.Narrative == null || data.personEventNarrativeDataResponse.Narrative.length == 0)) {
						FactEditModal.hasNarrativeDataWarning = true;
						var modalEditEvent = $('.tabContent4'),
							$banner = modalEditEvent.find('.eventAreaBannerWarning');
						displayBannerWarning($banner);
						FactEditModal.narrativeLoaded = false;
						generateNarrativeButton.hide();
						setButtonBasedOnValidation();
					} else {
						FactEditModal.narrativeLoaded = true;
					}
					narrativeTextArea.text(data.personEventNarrativeDataResponse.Narrative);
					narrativeTextArea.val(data.personEventNarrativeDataResponse.Narrative);

					/* Set a data attribute for the original value */
					narrativeTextArea.attr('data-original-narrative', data.personEventNarrativeDataResponse.Narrative || '');
				}
				var lifestoryTitleField = $('.lifestoryTitleField');
				if (lifestoryTitleField.length > 0) {
					lifestoryTitleField
						.attr('value', data.personEventNarrativeDataResponse.Title)
						.attr('data-original-lifestorytitle', data.personEventNarrativeDataResponse.Title);
				}
				/* Preset display on life story */
				if (displayLifestory.length > 0) {
					displayLifestory
						.prop('checked', !data.personEventNarrativeDataResponse.IsHidden)
						.attr('data-original-displaylifestory', (!data.personEventNarrativeDataResponse.IsHidden).toString());
				}
				$tabContent4.find('.narrativeIsMapOn').val(data.personEventNarrativeDataResponse.IsMapOn);
				$tabContent4.find('.narrativeIsImageOn').val(data.personEventNarrativeDataResponse.IsImageOn);
				$tabContent4.find('.narrativePreferredImageId').val(data.personEventNarrativeDataResponse.PreferredImageId);
			} else { /*  we still need to handle the checkbox otherwise we don't have a data attribute value if it is checked or not */
				/* Preset display on life story */
				if (displayLifestory.length > 0) {
					$tabContent4.find('.narrativeIsMapOn').val(false);
					$tabContent4.find('.narrativeIsImageOn').val(true);
					displayLifestory.prop('checked', false).attr('disabled', true).attr('data-original-displaylifestory', 'false');
				}
				/* did the get new narrative fail, even though we had a narrative before? */
				if (narrativeTextArea.text.length > 0) {
					FactEditModal.hasNarrativeDataWarning = true;
					var modalEditEvent = $('.tabContent4'),
						$banner = modalEditEvent.find('.eventAreaBannerWarning');
					displayBannerWarning($banner);
					FactEditModal.narrativeLoaded = false;
					generateNarrativeButton.hide();
					setButtonBasedOnValidation();
				}

			}
		}
	});
}

/* To turn on a success banner when saving */
function switchOnSuccessBanner(bannerArea) {
	/* If we saved the event then we are on that area and we show the banner there */
	bannerArea.text(FactEditModal.text.savedSuccessfullyBanner);
	if (bannerArea.hasClass('alertHidden')) {
		bannerArea.alert('open');
	} else {
		setTimeout(function () {
			bannerArea.alert('open');
		}, 10);
	}
}

/* This function is for relationship events being created, the spouse select section */
function showMultipleSpouseSelect() {
	/* Unbinding the click is essential or we can't save after warnings */
	FactEditModal.isAddNewSpouse = false;
	FactEditModal.showMultipleSpouseSelected = true;
	var modalEditEvent = $('.tabContent1'),
		individualSpouseSelect = modalEditEvent.find('#individualSpouseSelect'),
		multipleSpouseSelect = modalEditEvent.find('#multipleSpouseSelect');
	/* First we need to reset the individual spouse listing, and remove any selected person properties */
	var selectedPerson = modalEditEvent.find('.selectedPerson');
	/* We should have selectedPerson at this point, if not, then it could be from typeahead, so need to check */
	if (isRelationshipEventType() && selectedPerson.length === 0) {
		selectedPerson = modalEditEvent.find('.selectedPerson');
	}
	var hasSelectedPerson = (typeof (selectedPerson) != 'undefined' && selectedPerson.length > 0);
	if (hasSelectedPerson) {
		/* reset individual spouse node */
		var selectedSpouseId = selectedPerson.attr('id').replace('selectedSpouse', '').replace('-individual', '');
		/* Set the correct radio button */
		var selectedSpouseRadio = $('#selectedSpouseRadio' + selectedSpouseId);
		selectedSpouseRadio.prop('checked', 'checked');
		selectedPerson.hide();
	}
	/* Hide/Show elements */
	$('#changeSpouseButton').hide();
	$('#chooseOtherButton').show().attr('onclick', 'showSpouseTypeAheadSection();');
	var dontValidate = false,
		spouseCount = parseInt(FactEditModal.person.spouseCount);
	/*
		Handle if we have an event with no associated spouse for a person with 1 spouse, 
		else if with more than one, then handle the events with an associated spouse
	*/
	if (!FactEditModal.isAddNewFact && spouseCount === 1 && typeof (FactEditModal.originalSpouseId) != 'undefined' && FactEditModal.originalSpouseId.length === 0) {
		individualSpouseSelect.hide();
		multipleSpouseSelect.show();
		$('#singleScenarioSpouseSelect').show();
		$('#noSpouseForEventSingle').show();
		$('#noSpouseForEventMulti').hide();
		$('#chooseOtherButton').show().attr('onclick', 'showSpouseTypeAheadSection();');
	} else if (!FactEditModal.isAddNewFact && spouseCount > 1 && typeof (FactEditModal.originalSpouseId) != 'undefined' && FactEditModal.originalSpouseId.length === 0) {
		individualSpouseSelect.hide();
		$('#spouseText').hide();
		$('#selectSpouseForEventText').show();
		multipleSpouseSelect.show();
		$('#noSpouseForEventSingle').hide();
		$('#noSpouseForEventMulti').show();
		$('#chooseOtherButton').show().attr('onclick', 'showSpouseTypeAheadSection();');
	} else {
		if (spouseCount === 1) {
			if (hasSelectedPerson) {
				/* reset individual spouse node */
				var selectedSpouseId = selectedPerson.attr('id').replace('selectedSpouse', '').replace('-individual', '');
				resetIndividualSpouseNode(selectedPerson, selectedSpouseId);
			}
			/* We need to set all the data for the individual */
			setIndividualSpouseData(modalEditEvent, '.singleScenarioSpouseSelect');
			dontValidate = true;
			individualSpouseSelect.show();
			multipleSpouseSelect.hide();
		} else if (spouseCount === 0) {
			$('#noSpouseChooseOther').show();
			$('#chooseOtherButton').show().attr('onclick', 'showSpouseTypeAheadSection();');
		} else {
			/* Hide/Show elements */
			individualSpouseSelect.hide();
			$('#spouseText').hide();
			/* Show multiple list of spouses (including the individual one) */
			$('#selectSpouseForEventText').show();
			multipleSpouseSelect
				.show()
				.addClass('multipleSpouseSelected');
			/* We need to set all the data for the individual */
			if (FactEditModal.previousSelectedSpouseHTML.length > 0 && FactEditModal.previousSelectedSpouseHTML.indexOf('selectedPerson') !== -1) {
				modalEditEvent
					.find('#individualSpouseSelect')
					.html(FactEditModal.previousSelectedSpouseHTML);
			}
		}
	}
	/* Reset save/create button to validate due to showing the typeahead will unset the selected spouse */
	if (!dontValidate && (!hasSelectedPerson)) {
		setFactActionWithValidate();
	} else {
		if (FactEditModal.isAddNewFact) {
			setAddNewFactCreateAction();
		} else {
			setFactModalTabsClick(FactEditModal.hasValidationError);
		}
	}
}

/* This function is for relationship events being created, the spouse select section */
function showIndividualSpouse() {
	FactEditModal.isAddNewSpouse = false;
	FactEditModal.showMultipleSpouseSelected = false;
	var modalEditEvent = $('.tabContent1'),
		individualSpouseSelect = modalEditEvent.find('#individualSpouseSelect'),
		multipleSpouseSelect = modalEditEvent.find('#multipleSpouseSelect');
	var spouseCount = parseInt(FactEditModal.person.spouseCount);
	if (spouseCount >= 1) {
		/* Show individual spouse node */
		var singleScenarioSpouseSelect = $('#singleScenarioSpouseSelect');
		if (spouseCount === 1 && singleScenarioSpouseSelect.length > 0 &&
			typeof ($('#singleScenarioSpouseSelect').attr('style').length) !== 'undefined' &&
			$('#singleScenarioSpouseSelect').attr('style').length === 0) {
			$('#changeSpouseButton').hide();
			$('#chooseOtherButton').show().attr('onclick', 'showSpouseTypeAheadSection();');
		} else {
			$('#changeSpouseButton').show().attr('onclick', 'showMultipleSpouseSelect();');
			$('#chooseOtherButton').hide();
		}
	}
	$('#spouseText').show();
	/* Hide multiple list of spouses (including the individual one) */
	$('#selectSpouseForEventText').hide();
	/* We need to set all the data for the individual */
	if (setIndividualSpouseData(modalEditEvent, '.selectedPerson')) {
		$('#noSpouseForEventSingle').hide();
		$('#noSpouseForEventMulti').hide();
	}
	else {
		return false;
	}

	if (spouseCount > 0) {
		individualSpouseSelect.show();
		multipleSpouseSelect.hide();
	}

	/* Show new individual spouse node*/
	var existingSpouseIndividual2 = individualSpouseSelect.find('.existingSpouseIndividual');
	if (existingSpouseIndividual2.length > 0 && existingSpouseIndividual2.hasClass('selectedPerson')) {
		existingSpouseIndividual2.show();
	}
	multipleSpouseSelect.removeClass('multipleSpouseSelected');
	return true;
}

/* Perform functionality in showing an individual spouse after selecting them, which is common to adding a spouse and selecting existing */
function showIndividualSpouseCommon(modalEditEvent, selectedPerson, selectedSpouseIndividual) {
	if (typeof (selectedPerson) != 'undefined' && selectedPerson.length > 0) {
		/* We need to remove any OLD items that have selectedPerson class */
		selectedPerson
			.removeClass('selectedPerson')
			.removeAttr('style');
		/* Add the selectedPerson class to the new individual */
		selectedSpouseIndividual
			.addClass('selectedPerson')
			.attr('data-assertionId', selectedPerson.attr('data-assertionId'))
			.attr('data-spouseLifeRange', selectedPerson.attr('data-spouseLifeRange'));
		/* Temporarily commenting out until we figure out view profile using the PUB stuff to return with modal open */
		/*selectedSpouseIndividual.find('.viewProfileButton').attr('onclick', selectedPerson.find('.viewProfileButton').attr('onclick')); */
		/* Only show the spouse select warning if they try to click the save button */
		/* Set click action for the edit modal save button */
		/* deprecated??? */
		setEditModalSaveButtonClick();
	}
}

/* handle if a relationship event, checking the dates for the spouse to make sure the event gets warned on dates outside of the liferange */
function validateRelationshipEventAgainstSpouseData(selectedPerson, eventType, dateField, isCreate) {
	var hasValidationWarning = false,
		validationMessage = FactEditModal.text.warnDateMayBeWrong + '  ';
	/* Override validation errors and reset things */
	overrideValidation();
	FactEditModal.hasValidationWarning = false;
	FactEditModal.validationWarningMessage = '';
	FactEditModal.warningMessage = '';
	var relationshipLifeRange = (typeof (selectedPerson) != 'undefined' && selectedPerson.length > 0 && typeof (selectedPerson.attr('data-spouseLifeRange')) != 'undefined' && selectedPerson.attr('data-spouseLifeRange').length > 0) ? selectedPerson.attr('data-spouseLifeRange').trim() : '';
	if (relationshipLifeRange.length > 0) {
		if (relationshipLifeRange.indexOf(':') !== -1) {
			var lifeRangeSplit = relationshipLifeRange.split(':');
			var eventResults = validDate(dateField, eventType.toString().toLowerCase(), FactEditModal.person.personBirth, FactEditModal.person.personDeath, FactEditModal.person.motherBirth, FactEditModal.person.motherDeath, FactEditModal.person.fatherBirth, FactEditModal.person.fatherDeath, false);
			/* Handle birth */
			if (lifeRangeSplit[0].length > 0) {
				/* Compare spouse birth to the fact date */
				if (parseInt(eventResults[1], 10) < lifeRangeSplit[0]) {
					hasValidationWarning = true;
					validationMessage += warnDateBeforeBirthOfSpouse;
				}
			}
			/* Handle death */
			if (lifeRangeSplit[1].length > 0) {
				/* Compare spouse death to the fact date */
				if (parseInt(eventResults[1], 10) > lifeRangeSplit[1]) {
					hasValidationWarning = true;
					validationMessage += warnDateAfterDeathOfSpouse;
				}
			}
			if (hasValidationWarning) {
				FactEditModal.hasValidationWarning = true;
				FactEditModal.validationWarningMessage = validationMessage;
				FactEditModal.warningMessage = '';
				setupCreateOrSaveAnywayTextButton();
				if (isCreate) {
					setAddNewFactCreateAction();
				} else {
					setFactModalTabsClick(FactEditModal.hasValidationError);
				}
				return false;
			}
		}
	}
	return true;
}

/* Handles showing the section for Select Person Typeahead for the spouse, and the Add Person button */
function showSpouseTypeAheadSection() {
	FactEditModal.isAddNewSpouse = true;
	/* First we need to reset the individual spouse listing, and remove any selected person properties */
	var modalEditEvent = $('.tabContent1');
	var selectedPerson = modalEditEvent.find('.selectedPerson');
	var spouseCount = parseInt(FactEditModal.person.spouseCount);
	$('#noSpouseForEventMulti').hide();
	$('#noSpouseForEventSingle').hide();
	/* Store individual node html so if we cancel from typeahead section, we can resee the selected node */
	FactEditModal.previousSelectedSpouseHTML = modalEditEvent.find('#individualSpouseSelect').html();
	if (typeof (selectedPerson) != 'undefined' && selectedPerson.length > 0) {
		/* reset individual spouse node */
		resetIndividualSpouseNode(selectedPerson, '');
	}
	if (spouseCount === 0) {
		$('#noSpouseChooseOther').hide();
	}
	/* Hide those sections and buttons necessary */
	$('#individualSpouseSelect').hide();
	$('#multipleSpouseSelect').hide();
	$('#selectSpouseForEventText').hide();
	$('#changeSpouseButton').hide();
	$('#chooseOtherButton').hide();
	/* Show those sections necessary */
	$('#spouseText').show();
	$('#typeAheadArea').show();
	$('.addRelationships').show();

	/* handle onclick for cancel and add person buttons */
	var typeAheadCancelButton = $('.erAddCancel');
	if (typeAheadCancelButton.length > 0) {
		typeAheadCancelButton.attr('onclick', 'hideSpouseTypeAheadSection();');
	}
	var typeAheadAddPersonButton = $('.erAddNew');
	if (typeAheadAddPersonButton.length > 0) {
		typeAheadAddPersonButton.attr('onclick', 'spouseTypeAheadSectionAddPersonModal();');
	}
	/* Init Type ahead on place/location field */
	var typeAheadSaveButton = $('.erAddSave');
	var $typeAheadNameField = $('.erFindExistingPerson');
	if ($typeAheadNameField.length > 0 && typeAheadSaveButton.length > 0) {
		typeAheadSaveButton.attr('onclick', 'selectFromSpouseTypeAhead(this);');
		$typeAheadNameField.data('itemData', '');
		typeAheadSaveButton.attr('disabled', 'disabled');
		personTypeAheadNameField($typeAheadNameField, FactEditModal.autocompletePidsToExclude, typeAheadSaveButton, 'factEditModal', false);
	}
}

/* Handles hiding the section for Select Person Typeahead for the spouse */
function hideSpouseTypeAheadSection() {
	FactEditModal.isAddNewSpouse = false;
	if (FactEditModal.previousSelectedSpouseHTML.length > 0 && FactEditModal.previousSelectedSpouseHTML.indexOf('selectedPerson') !== -1) {
		var modalEditEvent = $('.tabContent1');
		modalEditEvent.find('#individualSpouseSelect').html(FactEditModal.previousSelectedSpouseHTML);
		FactEditModal.previousSelectedSpouseHTML = '';
	}
	var spouseCount = parseInt(FactEditModal.person.spouseCount);
	if (spouseCount > 1) {
		FactEditModal.showMultipleSpouseSelected = true;
		$('#spouseText').hide();
		$('#selectSpouseForEventText').show();
	} else {
		FactEditModal.showMultipleSpouseSelected = false;
		$('#spouseText').show();
		$('#selectSpouseForEventText').hide();
	}
	$('#typeAheadArea').hide();
	var $typeAheadNameField = $('.erFindExistingPerson');
	if ($typeAheadNameField.length > 0) {
		$typeAheadNameField.data('itemData', '');
	}
	if (FactEditModal.hasExistingSpouseToSelect) {
		if (FactEditModal.showMultipleSpouseSelected || $('#singleScenarioSpouseSelect').attr('style').length === 0) {
			$('#multipleSpouseSelect').show();
			$('#chooseOtherButton').show().attr('onclick', 'showSpouseTypeAheadSection();');
			if (!FactEditModal.isAddNewFact && spouseCount === 1 && FactEditModal.originalSpouseId.length === 0) {
				$('#noSpouseForEventSingle').show();
				$('#noSpouseForEventMulti').hide();
			} else if (!FactEditModal.isAddNewFact && spouseCount > 1 && FactEditModal.originalSpouseId.length === 0) {
				$('#noSpouseForEventSingle').hide();
				$('#noSpouseForEventMulti').show();
			}
		} else {
			$('#individualSpouseSelect').show();
			if (spouseCount > 1) {
				$('#changeSpouseButton').show().attr('onclick', 'showMultipleSpouseSelect();');
			} else {
				$('#chooseOtherButton').show().attr('onclick', 'showSpouseTypeAheadSection();');
			}
		}
	} else if (spouseCount === 0) {
		$('#noSpouseChooseOther').show();
		$('#chooseOtherButton').show().attr('onclick', 'showSpouseTypeAheadSection();');
	}
	setupCreateOrSaveTextButton();
	setupCorrectClickActionLinks();
}

/* Changes the individual spouse node back to a blank state */
function resetIndividualSpouseNode(selectedPerson, selectedSpouseId) {
	if (typeof (selectedPerson) != 'undefined' && selectedPerson.length > 0) {
		selectedPerson
			.removeClass('selectedPerson')
			.removeAttr('style');
		FactEditModal.previousSelectedSpouseId = selectedSpouseId;
		FactEditModal.hasValidationWarningAgainstSpouseData = false;
		/* reset individual spouse node */
		selectedPerson.attr('id', 'selectedSpouse-individual');
		selectedPerson
			.find('.nodeImageDiv')
			.html('');
		selectedPerson
			.find('.userCardTitle')
			.text('');
		selectedPerson
			.find('.userCardSubTitle')
			.text('');
		selectedPerson.attr('data-assertionId', '0');
	}
}

/* Setup the onclick values for the tabs and save button */
function setFactActionWithValidate() {
	/* Save button */
	if (FactEditModal.isAddNewFact) {
		setAddNewFactCreateAction();
	} else {
		setFactModalTabsClick(FactEditModal.hasValidationError);
	}
}

/* Handles switching of selected spouses from the list */
function switchSelectedPersonClass(selectedItem) {
	/* Reset Individual Spouse Node */
	var modalEditEvent = $('.tabContent1'),
		selectedPerson = modalEditEvent.find('.selectedPerson');
	/* We should have selectedPerson at this point, if not, then it could be from typeahead, so need to check */
	if (isRelationshipEventType() && selectedPerson.length === 0) {
		selectedPerson = modalEditEvent.find('.selectedPerson');
	}
	if (typeof (selectedPerson) != 'undefined' && selectedPerson.length > 0 && typeof (selectedPerson.attr('id')) != 'undefined') {
		var origSelectedSpouseId = selectedPerson.attr('id').replace('selectedSpouse', '').replace('-individual', '');
		resetIndividualSpouseNode(selectedPerson, origSelectedSpouseId);
	}
	/* Get Selected Radio */
	var selectedSpouseId = selectedItem.id.replace('selectedSpouseRadio', ''),
		selectedSpouseItem = $('#selectedSpouse' + selectedSpouseId),
		spouseCount = parseInt(FactEditModal.person.spouseCount);
	if (FactEditModal.isAddNewFact || spouseCount > 0) {
		/* First we need to remove any items that have selectedPerson class */
		if (typeof (selectedSpouseItem) != 'undefined' && selectedSpouseItem.length > 0) {
			/* uncheck radio button of previously selected one*/
			var selectedSpouseRadio = $('#selectedSpouseRadio' + FactEditModal.previousSelectedSpouseId);
			selectedSpouseRadio.prop('checked', '');
			/* Add the selectedPerson class to the actual selected item */
			selectedSpouseItem.addClass('selectedPerson');
		}
	}
	FactEditModal.showMultipleSpouseSelected = false;
	/* Make sure the choose spouse button is shown */
	if (spouseCount === 1 || spouseCount > 1) {
		if (spouseCount === 1 && $('#singleScenarioSpouseSelect').attr('style').length === 0) {
			$('#changeSpouseButton').hide();
			$('#chooseOtherButton').show().attr('onclick', 'showSpouseTypeAheadSection();');
		} else {
			$('#changeSpouseButton').show().attr('onclick', 'showMultipleSpouseSelect();');
			$('#chooseOtherButton').hide();
		}
	}
	$('#spouseText').show();
	/* perform validation */
	setFactActionWithValidate();
	setButtonandBannerBasedOnValidation(false);
}

/* We need to set all the data for the individual */
function setIndividualSpouseData(modalEditEvent, selectedPersonClass) {
	var selectedPerson = modalEditEvent.find(selectedPersonClass),
		$selectedSpouseIndividual = modalEditEvent.find('#selectedSpouse-individual');
	if (typeof (selectedPerson) != 'undefined' && selectedPerson.length > 0) {
		$selectedSpouseIndividual.attr('id', selectedPerson.attr('id') + '-individual');
		$selectedSpouseIndividual
			.find('.nodeImageDiv')
			.html(selectedPerson.find('.nodeImageDiv').html());
		$selectedSpouseIndividual
			.find('.userCardTitle')
			.text(selectedPerson.find('.userCardTitle').text());
		$selectedSpouseIndividual
			.find('.userCardSubTitle')
			.text(selectedPerson.find('.userCardSubTitle').text());
	} else {
		return false;
	}
	showIndividualSpouseCommon(modalEditEvent, selectedPerson, $selectedSpouseIndividual);
	$selectedSpouseIndividual.addClass('selectedPerson');

	return true;
}

/* Set click action for the edit modal save button */
function setEditModalSaveButtonClick() {
	$('.editModalSaveButton').on('click', function (event) {
		/* Unbinding the click is essential or we can't save after warnings */
		event.stopPropagation();
	});
}

/* 	For selecting a spouse from typeahead dropdown.
	This will handle updating the data for the individual spouse node when the user clicks the save button */
function selectFromSpouseTypeAhead(e) {
	var modalEditEvent = $('.tabContent1');
	/* First we need to reset the individual spouse listing, and remove any selected person properties */
	var selectedPerson = modalEditEvent.find('.selectedPerson');
	if (typeof (selectedPerson) != 'undefined' && selectedPerson.length > 0) {
		/* reset individual spouse node */
		resetIndividualSpouseNode(selectedPerson, '');
	}
	var $this = $(e);
	var $card = $this.closest('.card');
	var $field = $card.find('.erFindExistingPerson');
	var data = $card.find('.erAddExistingData').data('itemData');
	var pid = data.PID;
	FactEditModal.findExistingPersonPID = pid;

	/* Get TypeAhead selected person data and put it in the individual spouse node */
	var personImage = data.image,
		personName = data.name,
		personBirth = data.birth,
		personDeath = data.death,
		genderIconType = data.genderIconType;
	var selectedSpouseIndividual = modalEditEvent.find('#selectedSpouse-individual');
	if (typeof (selectedSpouseIndividual) != 'undefined' && selectedSpouseIndividual.length > 0) {
		selectedSpouseIndividual.attr('id', 'selectedSpouse' + FactEditModal.findExistingPersonPID + '-individual');
		selectedSpouseIndividual.attr('data-isTypeAhead', 'true');
		var imageHtml = '';
		if (personImage.indexOf('mediasvc') !== -1) {
			imageHtml = '<div class="userCardImg userCardImgSquare userCardImgCenter" style="background-image:url(\'' + personImage.replace('"', '\"') + '\');"><img alt="" src="' + personImage + '"></div>';
		} else {
			imageHtml = '<div class="userCardImg userCardImgSquare icon icon' + genderIconType + '"></div>';
		}
		selectedSpouseIndividual
			.find('.nodeImageDiv')
			.html(imageHtml);
		selectedSpouseIndividual
			.find('.userCardTitle')
			.text(personName);
		var dates = (personBirth.length > 0 && personDeath.length > 0) ? personBirth + ' - ' + personDeath : ((personBirth.length > 0) ? personBirth + ' - ' : (personDeath.length > 0) ? ' - ' + personDeath : '');
		selectedSpouseIndividual.find('.userCardSubTitle').text(dates);
		if (!selectedSpouseIndividual.hasClass('selectedPerson')) {
			selectedSpouseIndividual.addClass('selectedPerson');
		}
		selectedSpouseIndividual.attr('data-assertionId', FactEditModal.findExistingPersonPID);
	}
	/* Temporarily commenting out until we figure out view profile using the PUB stuff to return with modal open */
	/*selectedSpouseIndividual.find('.viewProfileButton').attr('onclick', selectedPerson.find('.viewProfileButton').attr('onclick')); */
	/* Only show the spouse select warning if they try to click the save button */
	/* Set click action for the edit modal save button */
	/*setEditModalSaveButtonClick();*/
	/* Show the individual spouse with it's data*/
	$('#spouseText').show();
	$('#selectSpouseForEventText').hide();
	if ($field.length > 0) {
		$field.data('itemData', '');
	}
	$('#typeAheadArea').hide();
	$('#multipleSpouseSelect').hide();
	$('#individualSpouseSelect').show();
	$('.selectedPerson').show();
	var spouseCount = parseInt(FactEditModal.person.spouseCount);
	if (spouseCount === 0) {
		$('#noSpouseChooseOther').hide();
		$('#chooseOtherButton').show().attr('onclick', 'showSpouseTypeAheadSection();');
	} else {
		if (!FactEditModal.isAddNewFact && FactEditModal.originalSpouseId.length === 0) {
			if (spouseCount >= 1) {
				$('#changeSpouseButton').show().attr('onclick', 'showMultipleSpouseSelect();');
				$('#chooseOtherButton').hide();
			} else {
				$('#changeSpouseButton').hide();
				$('#chooseOtherButton').show().attr('onclick', 'showSpouseTypeAheadSection();');
			}
		} else if (FactEditModal.isAddNewFact && spouseCount > 0) {
			$('#chooseOtherButton').hide();
			$('#changeSpouseButton').show().attr('onclick', 'showMultipleSpouseSelect();');
		} else {
			$('#chooseOtherButton').hide();
			$('#changeSpouseButton').show().attr('onclick', 'showMultipleSpouseSelect();');
		}
		if (FactEditModal.previousSelectedSpouseId.length > 0) {
			var selectedSpouseRadio = $('#selectedSpouseRadio' + FactEditModal.previousSelectedSpouseId);
			selectedSpouseRadio.removeAttr('checked');
		}
	}
	/* Reset save/create button to have some save action due to the spouse being selected */
	var eventType = FactEditModal.eventType,
		dateField = modalEditEvent.find('.dateField').val();
	validateRelationshipEventAgainstSpouseData(selectedPerson, eventType, dateField, true);
	setButtonandBannerBasedOnValidation(true);
}

/* Override validation properties */
/* [deprecated] */
function overrideValidation() {
	/* Set the button to text default */
	if (FactEditModal.warningMessage.length > 0 && typeof ($('.editModalSaveButton').attr('disabled')) == 'undefined') {
		setupCreateOrSaveAnywayTextButton();
	} else {
		setupCreateOrSaveTextButton();
	}
	/* Reset warning boolean and message */
	resetValidationValues();
	/* Clear the call to validate from the links*/
	if (FactEditModal.isAddNewFact) {
		setAddNewFactCreateAction();
	}
	FactEditModal.warningMessage = '';
}

/* If we need to set the Create/Save button to Create Anyway/Save Anyway text*/
function setupCreateOrSaveAnywayTextButton() {
	if (FactEditModal.isAddNewFact) {
		$('.editModalSaveButton').text(FactEditModal.text.createAnyway);
	} else {
		$('.editModalSaveButton').text(FactEditModal.text.saveAnyway);
	}
}

/* Handles showing the Add Person Dialog */
function spouseTypeAheadSectionAddPersonModal() {
	var $mh = $('.modalHeader');
	var modalEditEvent = $('.tabContent1'),
		eventType = FactEditModal.eventType,
		dateField = modalEditEvent.find('.dateField').val(),
		placeField = modalEditEvent.find('.placeField').val(),
		descriptionField = modalEditEvent.find('.descriptionField').val(),
		addRelType = (FactEditModal.gender === 'Male') ? 'w' : 'h',
		genderType = (FactEditModal.gender === 'Male') ? 'F' : 'M',
		addPersonArgs = '{"rel":"' + addRelType + '","gender":"' + genderType + '",' +
			' "eventType": "' + eventType + '",' +
			' "dateField": "' + dateField + '",' +
			' "placeField": "' + placeField + '",' +
			' "descriptionField": "' + descriptionField + '",' +
			' "modalHeaderTitle": "' + (($mh.length > 0) ? escape($mh.text()) : '') + '",' +
			' "showAddNewOnly": "true",' +
			' "isAddNewSpouse": "true",' +
			' "selectedContentArea": "tabContent1",' +
			' "tabOrButtonItem": "factEditModalEvent"' + ((!FactEditModal.isAddNewFact) ? (', "assertionid": "' + FactEditModal.assertionId + '"') : '') +
			'}',
		addPersonPgStkArgs = 'pg=32768&pgpl=pid&pgps=' + FactEditModal.personId;
	/* Function that gets passed as a param to the Add Person Modal function that allows a transistion back to the Fact Modal */
	/* this apmCallback (the lowest level callback), is to be used for screen refresh, modal close, and redirecting to a new page, or back to a modal */
	var apmCallback = function (cbResponse) {
		if (!window.isCancelClicked && cbResponse.status === 'success') {
			if ($('.modalContents').length > 0) {
				$.modal.showLoading(true);
			}
		}
		var hasLifeStoryOptions = true;
		if (((eventType.toLowerCase() === 'birth' || eventType.toLowerCase() === 'death') && !isPrimary) || eventType.toLowerCase() === 'name' || eventType.toLowerCase() === 'gender')
			hasLifeStoryOptions = false;
		(FactEditModal.isAddNewFact) ? addNewFact(cbResponse.newPid, addPersonArgs) :
			newFactEditModal(window.PersonData, FactEditModal.assertionId, hasLifeStoryOptions, tabActivate, contentActivate, cbResponse.newPid, addPersonArgs, isCreateEvent, showTabs, doFEMLogging);
		return true;
	};
	AddPerson.Add(PersonData.treeId, PersonData.personId, addPersonArgs, apmCallback);
}

/* Check validation for events */
function validationCheck(eventType, eventResults) {
	/* Since we have a Date stamp built in the format: day,month,year we use that to validate, 
	so cases where the user inputs a month/year beyond our current */
	var returnValues = {
		hasValidationWarning: false,
		validationMessage: ''
	};
	if (eventResults[0] !== 0) {
		returnValues.hasValidationWarning = true;
		returnValues.validationMessage = FactEditModal.text.warnDateMayBeWrong;
	}
	var dateMonthYear = FactEditModal.person.dateStamp;
	if (dateMonthYear.length > 0) {
		/* dateSplit[0] is day */
		/* dateSplit[1] is month */
		/* dateSplit[2] is year */
		var dateSplit = dateMonthYear.split(',');
		/* eventResults[1] is year */
		/* eventResults[2] is month */
		/* eventResults[3] is day */
		/* Check month and day */
		/* If year is the same as the current, while month is after current */
		/* or if year and month are the same as current, and if the day is after current */
		if ((eventResults[2] != null && typeof (eventResults[2]) != 'undefined' && eventResults[1] === dateSplit[2] && parseInt(eventResults[2]) > parseInt(dateSplit[1])) ||
			(eventResults[2] != null && typeof (eventResults[2]) != 'undefined' && eventResults[1] === dateSplit[2] && parseInt(eventResults[2]) === parseInt(dateSplit[1]) && eventResults[3] != null && parseInt(eventResults[3]) > parseInt(dateSplit[0]))) {
			returnValues.hasValidationWarning = true;
			returnValues.validationMessage = FactEditModal.text.warnDateMayBeWrong + ' ' + FactEditModal.text.warnDateIsInFuture;
		} else if (eventResults[1].length > 0) {
			returnValues.validationMessage = (returnValues.validationMessage.length > 0) ? returnValues.validationMessage + ' ' + eventResults[1] : eventResults[1];
		}
	} else if (eventResults[1].length > 0) {
		returnValues.validationMessage = (returnValues.validationMessage.length > 0) ? returnValues.validationMessage + ' ' + eventResults[1] : eventResults[1];
	}
	return returnValues;
}

/* get the appropriate validation warning message */
function getWarningMessage(requiredEmpty, isEmpty) {
	return (requiredEmpty) ? (isEmpty) ? FactEditModal.text.warnToEnterTitleAndData : FactEditModal.text.warnToEnterTitle : FactEditModal.text.warnToEnterData;
}

/* Check if this is a relationship type */
function isDatePlaceEventType() {
	if (typeof (FactEditModal.datePlaceType) == 'undefined') {
		FactEditModal.datePlaceType = (FactEditModal.eventType !== 'Name' && FactEditModal.eventType !== 'Gender');
	}
	return FactEditModal.datePlaceType;
}

/* Add Fact Modal - the list of events to select from */
function addFactModal(persondata, trigger) {
	$addFactModalTrigger = $(trigger);
	$('<div>').modal({
		'showLoading': true,
		'$trigger': $addFactModalTrigger,
		'width': '400',
		'onOpen': function ($this) {
			if (typeof (persondata) == 'undefined') {
				$.modal.showLoading(false);
				$this.html(
					'<div class="ancGrid ancGridPadded">' +
					'<div class="ancCol w100">' +
					'<p>' + PersonCard.text.addPersonErrorText + '</p>' +
					'</div>' +
					'</div>'
				);
				console.log('persondata cannot be null');
			} else {
				window.PersonData = persondata;
				var url = getPersonAjaxUrlPrefix() + '/modals/addfact/tree/' + PersonData.treeId + '/person/' + PersonData.personId;
				$.ajax({
					type: 'GET',
					url: url,
					cache: false,
					timeout: 20000,
					success: function (data) {
						$.modal.showLoading(false);
						if (data.result) {
							$this
								.html(
								'<div class="modalHasTitle">' +
								'<div class="modalHeader">' +
								'<h4 class="modalTitle">' + PersonData.menu.facts.addFactTitle + '</h4>' +
								'</div>' +
								data.html +
								'</div>'
								)
								.find('.alertNote')
								.alert(personViewModalAlertSettingsNote)
								.end()
								.find('.alertInfo')
								.alert(personViewModalAlertSettingsInfo)
								.end()
								.find('.alertSuccess')
								.alert(personViewModalAlertSettingsSuccess)
								.end()
								.find('.alert:not(.alertNote):not(.alertInfo):not(.alertSuccess)')
								.alert(personViewModalAlertSettingsWarning)
								.end()
								.on('change', '#addFactSelect', function (e) {
									var selectedFactType = $(this).find('option:selected');
									if (selectedFactType.hasClass('creatableOption')) {
										personAnalyticsTrackClick('addNewFact' + selectedFactType.val());
										addNewFact();
									}
									/* click tracking for add fact modal */
									$('#modalClose').on('click.addFactModalCloseButton', function () {
										personAnalyticsTrackClick('addFactModalCloseButton');
									});
								});
						} else {
							$this.html(
								'<div class="ancGrid ancGridPadded">' +
								'<div class="ancCol w100">' +
								'<p>' + PersonCard.text.addPersonErrorText + '</p>' +
								'</div>' +
								'</div>'
							);
						}
					},
					error: function () {
						$.modal.showLoading(false);
						$this.html(
							'<div class="ancGrid ancGridPadded">' +
							'<div class="ancCol w100">' +
							'<p>' + PersonCard.text.addPersonErrorText + '</p>' +
							'</div>' +
							'</div>'
						);
					}
				});
			}
		},
		'onClose': function () {
			/* Remove click tracking for the modal */
			$('#modalClose').off('click.addFactModal');
		}
	});
}

/* Add NEW Fact Modal - the actual event details to save */
function addNewFact(newRelationshipPid, saveEventData) {
	var isValidaNewRelationshipPID = typeof (newRelationshipPid) != 'undefined' && newRelationshipPid.length > 0,
		eventType = $('#addFactSelect').val(),
		dateFieldVal = '',
		placeFieldVal = '',
		descriptionFieldVal = '',
		modalHeaderTitle = '',
		isPrimary = false,
		saveEventDataObj = '',
		isCreateRelationshipEvent = false,
		newPersonPid = '';
	PersonData.hasAddedNewSpouse = false;
	PersonData.newAddedSpouseId = '';
	/* Check if we added a new relationship event - means we have a new RID and data from the create event modal */
	if (isValidaNewRelationshipPID) {
		isCreateRelationshipEvent = true;
		newPersonPid = newRelationshipPid;
		PersonData.hasAddedNewSpouse = true;
		PersonData.newAddedSpouseId = newRelationshipPid;
	}
	if (typeof (saveEventData) != 'undefined' && saveEventData.length > 0) {
		/* The data coming through is json data (eventType, date, place, description) */
		saveEventDataObj = jQuery.parseJSON(saveEventData);
		eventType = saveEventDataObj.eventType,
			dateFieldVal = saveEventDataObj.dateField,
			placeFieldVal = saveEventDataObj.placeField,
			descriptionFieldVal = saveEventDataObj.descriptionField,
			modalHeaderTitle = saveEventDataObj.modalHeaderTitle,
			isPrimary = false;
		if (saveEventDataObj.isAddNewSpouse === 'true') {
			/* Reset warnings and states */
			ResetWarningsAndValues();
			FactEditModal.isAddNewSpouse = true;
		}
	}
	var url = getPersonAjaxUrlPrefix() + '/modals/addnewfact/tree/' + PersonData.treeId + '/person/' + PersonData.personId;
	$('<div>').modal({
		'showLoading': true,
		'$trigger': $addFactModalTrigger,
		'useCustomPadding': true,
		'onOpen': function ($this) {
			$.ajax({
				type: 'GET',
				url: url,
				cache: false,
				timeout: 20000,
				data: {
					eventType: eventType,
					newPersonPid: newPersonPid
				},
				success: function (data) {
					$.modal.showLoading(false);
					if (data.result) {
						$.modal.resize(760);
						if (isValidaNewRelationshipPID) {
							var addPerson = $('#AddPerson');
							if (addPerson.length > 0) {
								$('#AddPerson').remove();
							}
						}
						/* Content */
						$this
							.html(data.html)
							.find('.alertNote')
							.alert(personViewModalAlertSettingsNote)
							.end()
							.find('.alertInfo')
							.alert(personViewModalAlertSettingsInfo)
							.end()
							.find('.alertSuccess')
							.alert(personViewModalAlertSettingsSuccess)
							.end()
							.find('.alert:not(.alertNote):not(.alertInfo):not(.alertSuccess)')
							.alert(personViewModalAlertSettingsWarning);
						/* Setup the fact modal person node in the title details */
						setupFactModalUserCard();
						/* Set the fact details as the active content */
						$('#factEditModalEvent').addClass('tabActive active');
						$('.tabContent1').addClass('tabActive active');
						var spouseCount = parseInt(FactEditModal.person.spouseCount);
						if (isRelationshipEventType() && (isValidaNewRelationshipPID || spouseCount > 0)) {
							var dateField = $('.dateField');
							if (dateField.length > 0) {
								dateField.val(dateFieldVal);
							}
							var placeField = $('.placeField');
							if (placeField.length > 0) {
								placeField.val(placeFieldVal);
							}
							var descriptionField = $('.descriptionField');
							if (descriptionField.length > 0) {
								descriptionField.val(descriptionFieldVal);
							}
							var $iSpouseSelect = $('#individualSpouseSelect');
							if ($iSpouseSelect.is(':visible')) {
								if ($('#multipleSpouseSelect').is(':visible') && spouseCount > 1) {
									$('#changeSpouseButton').show().attr('onclick', 'showMultipleSpouseSelect();');
									$('#chooseOtherButton').hide();
								} else {
									$('#changeSpouseButton').hide();
									$('#chooseOtherButton').show().attr('onclick', 'showSpouseTypeAheadSection();');
								}
								var $indvSpouseSelect = $iSpouseSelect.find('.existingSpouseIndividual');
								if ($indvSpouseSelect.length > 0) {
									$indvSpouseSelect.addClass('selectedPerson');
								}
								$('#multipleSpouseSelect').hide();
							} else {
								var $indvSpouseSelect = $iSpouseSelect.find('.existingSpouseIndividual');
								if ($indvSpouseSelect.length > 0) {
									$indvSpouseSelect.removeClass('selectedPerson');
								}
								if (spouseCount < 2) {
									$('#individualSpouseSelect').show();
									$('#multipleSpouseSelect').hide();
								}
								$('#changeSpouseButton').hide();
								$('#chooseOtherButton').show().attr('onclick', 'showSpouseTypeAheadSection();');
							}
						}
						/* Setup typeahead for various fields */
						var dateField = $('#date');
						if (dateField.length > 0 && typeof (PersonCard.autoCompleteDates) != "undefined" && PersonCard.autoCompleteDates == true) {
							initDateAutoCompleteValidator(dateField);
						}
						var locationField = $('#location');
						if (locationField.length > 0) {
							initPlaceAutoCompleteValidator(PersonData.treeId, locationField);
						}
						/* Deal with preferred checkbox, don't show if we already have a birth or death */
						if (FactEditModal.eventType.toLowerCase() === 'birth' || FactEditModal.eventType.toLowerCase() === 'death') {
							if ($('.card').hasClass('preferredEvent' + FactEditModal.eventType)) {
								$('#preferredEventCheckbox').show();
							}
						} else if (FactEditModal.eventType.toLowerCase() === 'name') {
							$('#preferredEventCheckbox').show();
							if (FactEditModal.person.fatherSurname.length > 0) {
								var modalEditEvent = $('.tabContent1');
								modalEditEvent.find('#surname').val(FactEditModal.person.fatherSurname);
							}
						}
						/* If the event is a gender, then we only have radio buttons where one is selected by default 
							* and the create button should always be enabled and the onclick actions don't need validation.
							* Otherwise they do.
							*/
						if (FactEditModal.eventType === 'Gender') {
							$('.editModalSaveButton').removeAttr('disabled');
							setAddNewFactCreateAction();
						} else {
							if (FactEditModal.eventType === 'Name') {
								$('.editModalSaveButton').removeAttr('disabled');
							} else {
								if (isRelationshipEventType()) {
									if (dateFieldVal === '' && placeFieldVal === '' && descriptionFieldVal === '') {
										/* The save button needs to be disabled by default */
										$('.editModalSaveButton').attr('disabled', 'disabled');
									}
								}
								/* Set the button to text default */
								setupCreateOrSaveTextButton();
							}
							/* Need to setup onclick events for the buttons and tabs */
							setFactActionWithValidate();
						}
						/* Validate for new person added on relationship event */
						if (isValidaNewRelationshipPID) {
							FactEditModal.isAddNewSpouse = true;
						}
						/* If this is a relationship type event, then have checking in place for selecting spouse if clicking a tab */
						else if (isRelationshipEventType()) {
							setAddNewFactCreateAction();
							/* Only show the spouse select warning if they try to click the save button */
							/* If no spouses to select from then show the Select person from your or Add Person */
							if (spouseCount === 0 && FactEditModal.isAddNewFact) {
								$('#chooseOtherButton').hide();
								$('.addRelationships').show();
								showSpouseTypeAheadSection();
								$('.erAddCancel').hide();
							}
						}
						setButtonandBannerBasedOnValidation(false);
					} else {
						$this.html(
							'<div class="ancGrid ancGridPadded">' +
							'<div class="ancCol w100">' +
							'<p>' + PersonCard.text.addPersonErrorText + '</p>' +
							'</div>' +
							'</div>'
						);
					}
				},
				error: function () {
					$.modal.showLoading(false);
					$this.html(
						'<div class="ancGrid ancGridPadded">' +
						'<div class="ancCol w100">' +
						'<p>' + PersonCard.text.addPersonErrorText + '</p>' +
						'</div>' +
						'</div>'
					);
				}
			});
			/* Temporary (TODO: Remove when global fix is on live.) */
			if (window.navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
				$('html').addClass('iOSFix');
			}
		}
	});
}

/* deprecated, use newFactEditModal */
function factEditModal(treeId, personId, assertionId, hasLifeStoryOptions, tabActivate, contentActivate, addPersonNewPID, saveEventData, isFromCreateEvent) {
	throw "FactEditModal is deprecated, use newFactEditModal";
}

/* Setup the onclick values for the tabs and save button */
function setAddNewFactCreateAction() {
	/* Save button */
	$('.editModalSaveButton').attr('onclick', 'createNewEvent(\'tabContent1\', \'editModalSaveButton\');');
	/* Event edit */
	$('#factEditModalEvent').attr('onclick', 'createNewEvent(\'tabContent1\', \'factEditModalEvent\');');
	/* Attach Media */
	$('#factEditModalAttachMedia').attr('onclick', 'createNewEvent(\'tabContent2\', \'factEditModalAttachMedia\');');
	/* Associated Source Citations */
	$('#factEditModalSourceCitations').attr('onclick', 'createNewEvent(\'tabContent3\', \'factEditModalSourceCitations\');');
	/* Associated Timeline Options */
	$('#factEditModalTimelineOptions').attr('onclick', 'createNewEvent(\'tabContent4\', \'factEditModalTimelineOptions\');');
}
/* toggle the enabled on the buttons  */
function toggleAddNewFactCreateAction(enable) {
	if (enable) {
		$('.editModalSaveButton').removeAttr('disabled').removeClass('disabled');
		$('#factEditModalEvent').removeAttr('disabled').removeClass('disabled');
		$('#factEditModalAttachMedia').removeAttr('disabled').removeClass('disabled');
		$('#factEditModalSourceCitations').removeAttr('disabled').removeClass('disabled');
		$('#factEditModalTimelineOptions').removeAttr('disabled').removeClass('disabled');
	} else {
		$('.editModalSaveButton').addClass('disabled').attr('disabled', 'true');
		$('#factEditModalEvent').addClass('disabled').attr('disabled', 'true');
		$('#factEditModalAttachMedia').addClass('disabled').attr('disabled', 'true');
		$('#factEditModalSourceCitations').addClass('disabled').attr('disabled', 'true');
		$('#factEditModalTimelineOptions').addClass('disabled').attr('disabled', 'true');
	}
}

/* Reset warnings and values for validation */
function ResetWarningsAndValues() {
	var modalEditEvent = $('.tabContent1');
	modalEditEvent
		.find('.eventAreaBanner')
		.alert('close');
	modalEditEvent
		.find('.eventAreaBannerWarning')
		.alert('close');
	resetValidationValues();
	setupCreateOrSaveTextButton();
}

/* Create New Fact Action */
function createNewEvent(selectedContentArea, tabOrButtonItem) {
	toggleAddNewFactCreateAction(false);
	var modalEditEvent = $('.tabContent1');
	/* Set variables */
	var modalEditEventActive = modalEditEvent.hasClass('tabActive'),
		selectedPerson = modalEditEvent.find('.selectedPerson'),
		isCreateRelationshipEvent = false,
		eventType = FactEditModal.eventType,
		isPrimary = false,
		/* Check if we have any changed data from the original */
		eventChanged = false,
		isFailedSpouseData = false;
	/* 	Get the modal field details
		Event Values/Fields 
		(as a note, we have to use the jquery attr to get data fields versus the data function, as the data function will get the data once and then becomes immutable
		even if we update the data attribute later, the function will always get the original value it did once -- with attr we can get any newly updated data from the data attribute) */
	/* Now check the state if each field's data-state, and don't save if there was nothing changed */
	var dictionary = [];
	eventChanged = (modalEditEventActive) ? checkFieldValidation(true, true, dictionary) : false;
	/* Set a relationshipId of the other person if one exists */
	var relationshipEventType = isRelationshipEventType();
	/* We should have selectedPerson at this point, if not, then it could be from typeahead, so need to check */
	var relationshipId = (typeof (selectedPerson) != 'undefined' && selectedPerson.length > 0 && typeof (selectedPerson.attr('data-assertionId')) != 'undefined' && selectedPerson.attr('data-assertionId').length > 0) ? selectedPerson.attr('data-assertionId') : '';
	/* We should have relationshipId at this point, if not, then it could be from typeahead, so need to check */
	var isFindExistingPerson = false;
	if (relationshipEventType && (relationshipId === '0' || relationshipId.length === 0)) {
		var dataExtra = (typeof (selectedPerson) != 'undefined' && selectedPerson.length > 0 && typeof (selectedPerson.attr('data-extra')) != 'undefined' && selectedPerson.attr('data-extra').length > 0) ? selectedPerson.attr('data-extra') : '';
		if (typeof (dataExtra) != 'undefined' && dataExtra.length > 0) {
			dataExtra = jQuery.parseJSON(dataExtra);
		}
		relationshipId = (typeof (dataExtra) != 'undefined') ? dataExtra.PID : '';
		isCreateRelationshipEvent = true;
		FactEditModal.originalSpouseId = relationshipId;
		isFindExistingPerson = true;
	}
	/* Validate relationship data */
	var relTypeAheadVal = 'false';
	if (relationshipEventType && relationshipId != null && relationshipId !== '') {
		relTypeAheadVal = (typeof (selectedPerson) != 'undefined' && selectedPerson.length > 0 && typeof (selectedPerson.attr('data-isTypeAhead')) != 'undefined' && selectedPerson.attr('data-isTypeAhead').length > 0) ? selectedPerson.attr('data-isTypeAhead') : ((isFindExistingPerson) ? 'true' : 'false');
		if (relTypeAheadVal === 'true') {
			isCreateRelationshipEvent = true;
		}
		FactEditModal.originalSpouseId = relationshipId;
	}
	/* handle if a relationship event, checking the dates for the spouse to make sure the event gets warned on dates outside of the liferange */
	if (modalEditEventActive && !FactEditModal.hasValidationWarningAgainstSpouseData && relationshipEventType) {
		var dateField = modalEditEvent.find('.dateField').val();
		if (typeof (dateField) != 'undefined' && dateField.length > 0) {
			eventChanged = validateRelationshipEventAgainstSpouseData(selectedPerson, eventType, dateField, true, isFailedSpouseData);
			isFailedSpouseData = !eventChanged;
			FactEditModal.hasValidationWarningAgainstSpouseData = isFailedSpouseData;
		}
	}

	/* If we have a change to the event then we can save off the changes */
	if (eventChanged && modalEditEventActive) {
		/* get the values for the save from the validation dictionary */
		var titleField = (typeof (dictionary['title']) != 'undefined') ? dictionary['title'].value : '',
			dateField = (typeof (dictionary['date']) != 'undefined') ? dictionary['date'].value : '',
			placeField = '', placeFieldDataExtra = '';
		if (typeof (dictionary['location']) != 'undefined') {
			placeField = dictionary['location'].value;
			if (typeof (dictionary['location'].extra) != 'undefined') {
				placeFieldDataExtra = dictionary['location'].extra;
			}
		}
		var descriptionField = (typeof (dictionary['description']) != 'undefined') ? dictionary['description'].value : '',
			valueField = (typeof (dictionary['value']) != 'undefined') ? dictionary['value'].value : '',
			givenNameField = (typeof (dictionary['givenName']) != 'undefined') ? dictionary['givenName'].value : '',
			surnameField = (typeof (dictionary['surname']) != 'undefined') ? dictionary['surname'].value : '',
			suffixNameField = (typeof (dictionary['suffix']) != 'undefined') ? dictionary['suffix'].value : '',
			genderTypeField = (typeof (dictionary['genderMale']) != 'undefined') ? "Male" : (typeof (dictionary['genderFemale']) != 'undefined') ? "Female" : "Unknown";

		/* Update buttons when saving */
		handleButtonsSavingMode();
		/* Since we are creating a new fact, and if we are adding a vital fact for the first time, then we need to pass along that this is the primary */
		if (FactEditModal.isPrimary) {
			isPrimary = true;
		}
		/* also check to see if the check-box for 'is Primary' is checked */
		var $checkBox = modalEditEvent.find('.isPrimaryCheckbox');
		if ($checkBox.length > 0 && $checkBox.is(':checked')) {
			isPrimary = true;
		}
		var url = getPersonAjaxUrlPrefix() + '/tree/' + PersonData.treeId + '/person/' + PersonData.personId + '/createnewevent';
		$.ajax({
			type: 'POST',
			url: url,
			cache: false,
			timeout: 20000,
			data: {
				eventType: eventType,
				customEventTitle: titleField,
				date: dateField,
				place: placeField,
				description: (valueField != null && valueField.length > 0) ? valueField : descriptionField,
				relationshipId: relationshipId,
				relTypeAhead: relTypeAheadVal,
				isPrimary: isPrimary,
				givenName: givenNameField,
				surname: surnameField,
				suffixName: suffixNameField,
				genderType: genderTypeField
			},
			success: function (data) {
				/* Update buttons when back to normal */
				toggleAddNewFactCreateAction(true);
				handleButtonsNormalMode();
				if (data.result && typeof (data.assertionId) != 'undefined') {
					/* Update personcard date/place data fields */
					if ((typeof (isPrimary) != 'undefined' && isPrimary === true) && (eventType.toString() === 'Birth' || eventType.toString() === 'Death' || eventType.toString() === 'Name')) {
						if (eventType.toString() === 'Name') {
							/* Handle Name Event */
							if (typeof (surnameField) != 'undefined') {
								var fullname = ((givenNameField.length > 0) ? givenNameField : '') + ((surnameField.length > 0) ? ((givenNameField.length > 0) ? ' ' : '') + surnameField : '') + ((suffixNameField.length > 0) ? ' ' + suffixNameField : '');
								/* Set Person Card Name for person */
								$('#personCard .userCardTitle').html(fullname);
								/* Update Fact Modal usercard with new data */
								PersonCard.name = fullname;
								handleFactModalUserCardData('.userCardTitle', fullname);
							}
						} else {
							/* Update Fact Modal user card and Person Card */
							var hasBirth = PersonCard.lifeYearRange.indexOf('&ndash;') > 0 || PersonCard.lifeYearRange.indexOf('-') > 0;
							var hasDeath = ((PersonCard.lifeYearRange.indexOf('&ndash;') === 0 || PersonCard.lifeYearRange.indexOf('-') === 0) && PersonCard.lifeYearRange.length > 7) || PersonCard.lifeYearRange.length > 11;
							/* If the user is on family search, and added a new death event to the person, 
								* then reload the page to see the FS icon
								*/
							if (PersonCard.isFamilySearchUser && (!hasBirth && eventType.toLowerCase() === 'birth' || !hasDeath && eventType.toLowerCase() === 'death')) {
								location.reload();
							} else {
								var splitYears = (PersonCard.lifeYearRange.indexOf('&ndash;') !== -1) ? PersonCard.lifeYearRange.split('&ndash;') : PersonCard.lifeYearRange.split('-');
								var eventResults = validDate(dateField, eventType.toString().toLowerCase(), FactEditModal.person.personBirth, FactEditModal.person.personDeath, FactEditModal.person.motherBirth, FactEditModal.person.motherDeath, FactEditModal.person.fatherBirth, FactEditModal.person.fatherDeath, false);
								/* Update PersonCard to reflect changes from Fact Edit and the fact node */
								var dateSet = '';
								if (typeof (dateField) != 'undefined' && typeof (placeField) != 'undefined' && eventType.toString() === 'Birth') {
									window.getPersonCard();
									/* Update Fact Modal user card */
									dateSet = ((eventResults[0] === 0) ? eventResults[1] : ((splitYears.length > 0 && hasBirth) ? splitYears[0] : '')) + '&ndash;' + ((splitYears.length > 0 && hasDeath) ? ((splitYears.length > 1) ? splitYears[1] : splitYears[0]) : '');
									PersonCard.lifeYearRange = dateSet;
									if (dateSet.length > 1 && dateSet !== '&ndash;') {
										handleFactModalUserCardData('.userCardSubTitle', '(' + dateSet.replace('&ndash;', '-') + ')');
									} else {
										handleFactModalUserCardData('.userCardSubTitle', '');
									}
								} else if (typeof (dateField) != 'undefined' && typeof (placeField) != 'undefined' && eventType.toString() === 'Death') {
									window.getPersonCard();
									/* Update Fact Modal user card */
									dateSet = ((splitYears.length > 0 && hasBirth) ? splitYears[0] : '') + '&ndash;' + ((eventResults[0] === 0) ? eventResults[1] : ((splitYears.length > 0 && hasDeath) ? ((splitYears.length > 1) ? splitYears[1] : splitYears[0]) : ''));
									PersonCard.lifeYearRange = dateSet;
									if (dateSet.length > 1 && dateSet !== '&ndash;') {
										handleFactModalUserCardData('.userCardSubTitle', '(' + dateSet.replace('&ndash;', '-') + ')');
									} else {
										handleFactModalUserCardData('.userCardSubTitle', '');
									}
								}
							}
						}
					}
					/* Load the Edit Fact Modal */
					/*  We need to bring up the fact modal based on what tab/button we clicked on, so we will need to pass that info down into the
						factEditModal js function to make it active
						We don't want to show the edit fact modal if they clicked the create button, since we already edited the event data, we
						only want to show the modal if they clicked on one of the other tabs, like attached media
					*/
					if (tabOrButtonItem !== 'editModalSaveButton' && tabOrButtonItem !== 'factEditModalEvent') {
						/* as per #161045 If no narrative is available for event, display blank state instead, 
							* all facts except the alternates and name and gender have lifestoryoptions by default. 
							*/
						var hasLifeStoryOptions = true;
						if (((eventType.toLowerCase() === 'birth' || eventType.toLowerCase() === 'death') && !isPrimary) || eventType.toLowerCase() === 'name' || eventType.toLowerCase() === 'gender')
							hasLifeStoryOptions = false;
						newFactEditModal(PersonData, data.assertionId, hasLifeStoryOptions, tabOrButtonItem, selectedContentArea, '', '', true, true, doFEMLogging);
					} else {
						$.modal.close();
					}
					/* Handle showing the individual spouse */
					if (isCreateRelationshipEvent) {
						showIndividualSpouse();
					}
					/*  Reload the facts page content content. This must be done to see the newly created fact node without manually creating one
						so the user doesn't have to reload the page.
					*/
					setTimeout(function () {
						window.glue.reload();
					}, 1000);
					if ((typeof (PersonData.GrowlForValueOnlyAndAlternates) != 'undefined' && PersonData.GrowlForValueOnlyAndAlternates === true)) {
						/* We don't show name, gender or value only event in lifestory. So growl to user */
						if (isValueOnlyEventType() || eventType == "Name" || eventType == "Gender") {
							if (acom != null && acom.bus != null) {
								acom.bus.emit('LifeStory::Notify::Success', FactEditModal.text.lifeStoryValueOnlyEventGrowl, "", true);
							}
						}
						/* We don't show alternate birth, death in lifestory. So growl to user */
						if ((eventType == "Birth" || eventType == "Death") && !isPrimary) {
							if (acom != null && acom.bus != null) {
								acom.bus.emit('LifeStory::Notify::Success', FactEditModal.text.lifeStoryAlternateEventGrowl, "", true);
							}
						}
					}
				} else {
					var cancelClose = $('.cancelClose');
					if (cancelClose.length > 0) {
						cancelClose.show();
					}
					setButtonandBannerBasedOnValidation(true);
				}
			},
			error: function (xhr, ajaxOptions, thrownError) {
				throwException('status->' + xhr.status + ' thrownError->' + thrownError);
				/* Update buttons when back to normal */
				toggleAddNewFactCreateAction(true);
				handleButtonsNormalMode();
			}
		});
	} else {
		setButtonandBannerBasedOnValidation(true);
		toggleAddNewFactCreateAction(true);
	}
}

/* Handle updating the user card in the fact modal */
function handleFactModalUserCardData(titleSelector, titleData) {
	var factTitlePersonCard = $('.factTitlePersonCard');
	if (factTitlePersonCard.length > 0) {
		var userCardTitle = factTitlePersonCard.find(titleSelector);
		if (userCardTitle.length > 0) {
			userCardTitle.html(titleData);
		}
	}
}

/*	Generate new narrative
	What happens is we clear the narrative data from the field, 
	and if we save the narrative with no narrative data then the narrative service will generate one. */
function generateNarrativeDataModal(assertionid) {
	/* Get rid of narrative to force generation */
	$('#narrative.narrativeField').val('');
	closeCallouts();
	updateTabDisplay('factEditModalTimelineOptions');
	/* Call the save to save and force regeneration */
	savePersonNarrativeAndEventDataModal(assertionid, '', '', false, '', function () {
		updateTabDisplay('factEditModalTimelineOptions');
	});
}

/* ******** Citation/Source/Repository ********************* */
function setCitationStartPage(treeId, personId, citationId) {
	if (window.ancestry && window.ancestry.pub) {
		if (!citationId || citationId == '') {
			window.ancestry.pub.setCurrentPage('PersonFacts',
				{
					'TreeId': treeId,
					'PersonId': personId
				});
		} else {
			window.ancestry.pub.setCurrentPage('PersonFactsCitationEdit',
				{
					'TreeId': treeId,
					'PersonId': personId,
					'CitationId': citationId,
					'TabName': 'details'
				});
		}
	}
}
/* ******** Citation/Source/Repository ********************* */

/* ******** Source Edit Modal - START ********************** */

/* Source Edit Modal - edit Citation button action */
function editSourceModalEditCitation(treeId, personId, citationId) {
	if (window.ancestry && window.ancestry.pub) {
		setCitationStartPage(treeId, personId, citationId);
		window.ancestry.pub.buildUrl()
			.toGoTo('PersonCitationEdit', { 'TreeId': treeId, 'CitationId': citationId, 'PersonId': personId })
			.toComeBackToCurrent()
			.build(function (err, url) {
				if (err) {
					return;
				}
				window.location.href = url;
			});
	} else {
		var slashEdit = (window.PersonResearch.hasEditRights) ? "/edit" : '';
		var url = getPersonAjaxUrlPrefix() + '/tree/' + treeId + '/person/' + personId + '/citation/' + citationId + slashEdit;
		window.location.href = url;
	}
}

/* Source Edit Modal - edit Source button action */
function editSourceModalEditSource(treeId, personId, sourceId, citationId) {
	if (window.ancestry && window.ancestry.pub) {
		window.ancestry.pub.setCurrentPage('PersonFactsCitationEdit',
			{
				'TreeId': treeId,
				'PersonId': personId,
				'CitationId': citationId,
				'TabName': 'details'

			});
		window.ancestry.pub.buildUrl()
			.toGoTo('TreeSourceEdit', { 'TreeId': treeId, 'SourceId': sourceId, 'PersonId': personId, 'cid': citationId })
			.toComeBackToCurrent()
			.build(function (err, url) {
				if (err) {
					return;
				}
				if (url.indexOf(window.personUrlPrefix) < 0) {
					/* If we're heading to the trees stack, catch that and go to PersonUI stack */
					url = url.replace(window.treesUrlPrefix, window.personUrlPrefix); /* todo: temporary */
				}
				url = url + '&cid=' + citationId; /* todo: temporary */
				window.location.href = url;
			});
	} else {
		var slashEdit = (window.PersonResearch.hasEditRights) ? "/edit" : ''
		var url = getPersonAjaxUrlPrefix() + '/tree/' + treeId + '/person/' + personId + '/citation/' + citationId + slashEdit;
		window.location.href = url;
	}
}

/* Source Edit Modal - edit Source button action */
function editSourceModalEditRepository(treeId, personId, sourceId, citationId, repositoryId) {
	if (window.ancestry && window.ancestry.pub) {
		window.ancestry.pub.setCurrentPage('PersonFactsCitationEdit',
			{
				'TreeId': treeId,
				'PersonId': personId || null,
				'CitationId': citationId,
				'TabName': 'details'
			});
		window.ancestry.pub.buildUrl()
			.toGoTo('TreeRepositoryEdit', { 'TreeId': treeId, 'RepositoryId': repositoryId, 'SourceId': sourceId, 'PersonId': personId })
			.toComeBackToCurrent()
			.build(function (err, url) {
				if (err) {
					return;
				}
				if (url.indexOf(window.personUrlPrefix) < 0) {
					/* If we're heading to the trees stack, catch that and go to PersonUI stack */
					url = url.replace(window.treesUrlPrefix, window.personUrlPrefix); /* todo: temporary */
				}
				url = url + '&cid=' + citationId + '&pid=' + personId; /* todo: temporary */
				window.location.href = url;
			});
	} else {
		var slashEdit = (window.PersonResearch.hasEditRights) ? "/edit" : '';
		var url = getPersonAjaxUrlPrefix() + '/tree/' + treeId + '/person/' + personId + '/citation/' + citationId + slashEdit;
		window.location.href = url;
	}
}

/* Source Edit Modal - Associated Facts/Events Tab */
function sourceEditModalFacts() {
	/* Source Facts */
	var sourceFactsList = $('.sourceFactsList' + SourceEditModal.citationId);
	if (sourceFactsList.length > 0 && sourceFactsList.val() != null && sourceFactsList.val().length > 0) {
		setupSourceEditModalDetailsForFacts(sourceFactsList, true);
	}
	/* Non-Associated Source Facts */
	var unattachedSourceFactsList = $('.unattachedSourceFactsList' + SourceEditModal.citationId);
	if (unattachedSourceFactsList.length > 0 && unattachedSourceFactsList.val() != null && unattachedSourceFactsList.val().length > 0) {
		setupSourceEditModalDetailsForFacts(unattachedSourceFactsList, false);
	}
}

/* Update the details for each fact node on the Source Edit Modal */
function setupSourceEditModalDetailsForFacts(listItem, isAttached) {
	/* Quick function to determine tracking id. written this way since this 
		* function does not need to live beyond setting up the click event. */
	var getTrackingId = function (isAttached) {
		return (isAttached) ? 'editFactModalRemoveSource' : 'editFactModalAddSource';
	};
	/* Get the string list of fact ids */
	var factsList = listItem.val().split(',');
	if (factsList != null && factsList.length > 0) {
		/* Iterate on each fact id */
		$.each(factsList, function (i, factId) {
			var selector = '#modal_fi' + factId;
			/* Setup the click handler. We will determine what server call to make here and let the
				* setupCardClickEvent hook everything up. */
			setupCardClickEvent(selector, getTrackingId, function (isAttached, attachDetachCallback) {
				if (isAttached) {
					detachSourceFromEvent(factId, SourceEditModal.citationId, selector, attachDetachCallback);
				} else {
					attachSourceToEvent(factId, SourceEditModal.citationId, selector, attachDetachCallback);
				}
			});
		});
	}
}

/* Source Edit Modal - Attached Media Tab */
function sourceEditModalAttachedMedia(treeId, personId, citationId) {
	var url = getPersonAjaxUrlPrefix() + '/modals/sourceedit/tree/' + treeId + '/person/' + personId + '/citationid/' + citationId + '/attachedmedia?noRecordMedia=true';
	$.ajax({
		type: 'GET',
		url: url,
		cache: false,
		timeout: 20000,
		success: function (data) {
			if (data.result && data.html != null && data.html.length > 0) {
				/* Set HTML */
				$('#attachedMediaListSource')
					.removeClass('loading')
					.html(data.html.replace(/CitationIdValReplace/g, citationId))
					.find('.alertNote')
					.alert(personViewModalAlertSettingsNote)
					.end()
					.find('.alertInfo')
					.alert(personViewModalAlertSettingsInfo)
					.end()
					.find('.alertSuccess')
					.alert(personViewModalAlertSettingsSuccess)
					.end()
					.find('.alert:not(.alertNote):not(.alertInfo):not(.alertSuccess)')
					.alert(personViewModalAlertSettingsWarning);
				/* Check if there was a media failure error and show the correct message */
				if ($('.sortingDivHasError').length) {
					showModalAlerts(true, '.sortingDivBottomSourceMedia', '.sortingDivTopSourceMedia');
				} else {
					/* Unbind the click so we don't get media again */
					$('#sourceEditModalAttachMedia').off('click');
					/* Initialize the media items - set up the attach/detach handling of sorting icon clicks */
					sourceEditModalMedia(data.attachedMediaIds, data.unAttachedMediaIds);
					sortingCardOutlineHover();
					showModalAlerts(false, '.sortingDivBottomSourceMedia', '.sortingDivTopSourceMedia');
					/* This is used for Attach Media on Sources */
					$.cachedScript(PersonResearch.animateCardUrl).done(function () {
						sortCard('.sortingDivBottomSourceMedia', '.sortingDivTopSourceMedia');
					});
				}
			} else {
				$('#attachedMeidaListSource').removeClass('loading');
				showModalAlerts(true, '.sortingDivBottomSourceMedia', '.sortingDivTopSourceMedia');
			}
		},
		error: function () {
			$('#attachedMeidaListSource').removeClass('loading');
			showModalAlerts(true, '.sortingDivBottomSourceMedia', '.sortingDivTopSourceMedia');
		}
	});
}
/* ******** Source Edit Modal - END ********************** */
/* Source Edit Modal - Associated Media Tab */
function sourceEditModalMedia(attachedMediaIds, unAttachedMediaIds) {
	/* Event Media */
	if (attachedMediaIds.length > 0) {
		setupSourceEditModalDetailsForMedia(attachedMediaIds, window.SourceEditModal.citationId, true);
	}
	/* Non-Associated Event Media */
	if (unAttachedMediaIds.length) {
		setupSourceEditModalDetailsForMedia(unAttachedMediaIds, window.SourceEditModal.citationId, false);
	}
}
/* Update the attach/detach click state for media on the source */
function setupSourceEditModalDetailsForMedia(eventMediaIds, citationId, isAttached) {

	/* Quick function to determine tracking id. written this way since this 
		* function does not need to live beyond setting up the click event. */
	var getTrackingId = function (isAttached) {
		return (isAttached) ? 'removeMediaFromCitation' : 'attachMediaToCitation';
	};

	/* Get the string list of fact ids */
	var mediaList = eventMediaIds.split(',');
	if (mediaList != null && mediaList.length > 0) {
		/* Iterate on each media id */
		$.each(mediaList, function (i, mediaId) {
			/* Setup the click handler. We will determine what server call to make here and let the
				* setupCardClickEvent hook everything up. */
			var selector = '#card' + mediaId;
			setupCardClickEvent(selector, getTrackingId, function (isAttached, attachDetachCallback) {
				if (isAttached) {
					detachMediaFromCitation(citationId, mediaId, attachDetachCallback);
				} else {
					attachMediaToCitation(citationId, mediaId, attachDetachCallback);
				}
			});
		});
	}
}
/* Sort Card*/
function sortCard(sortBottom, sortTop) {
	$(sortBottom).animateCard({
		items: '.sortingCard',
		animateMove: {
			afterAnimate: function (item) {
				if (item.find('.sortingIcon').hasClass('iconAdd')) {
					if (item.hasClass('card')) {
						item
							.removeClass('cardOutline2')
							.addClass('attached');
					} else {
						item
							.addClass('attached')
							.find('.card')
							.removeClass('cardOutline2');
					}
					item
						.find('.sortingIcon')
						.removeClass('iconAdd noHover')
						.addClass('iconClose');
					/* Accessibility (Visually hidden text needs to toggle between attach and unattach.) */
					swapText(item);
				} else {
					if (item.hasClass('card')) {
						item
							.removeClass('cardOutline2')
							.removeClass('attached');
					} else {
						item
							.removeClass('attached')
							.find('.card')
							.removeClass('cardOutline2');
					}
					item
						.find('.sortingIcon')
						.removeClass('iconClose noHover')
						.addClass('iconAdd');
					/* Accessibility (Visually hidden text needs to toggle between attach and unattach.) */
					swapText(item);
				}
				window.lock.actionInProgress = false;
			},
			beforeAnimate: function (item) {
				item
					.find('.card')
					.addClass('cardOutline2');
			},
			connectWith: sortTop,
			emptyContent: '.alertInfo'
		},
		onListEmpty: function (emptyList) {
			emptyList
				.find('.alertInfo')
				.alert('open');
		},
		onEmptyListAdd: function (list) {
			list
				.find('.alertInfo')
				.alert('close');
		}
	});
}
/* Accessibility (Visually hidden text needs to toggle between attach and unattach.) */
function swapText(item) {
	var el = item.find('.hideVisually');
	el.text() == el.data("text-swap")
		? el.text(el.data("text-original"))
		: el.text(el.data("text-swap"));
}
function fixTitleText(title) {
	var newTitle = unescape(title);
	while (newTitle.indexOf("&quot;") !== -1) {
		newTitle = newTitle.replace("&quot;", "\"");
	}
	while (newTitle.indexOf("&amp;") !== -1) {
		newTitle = newTitle.replace("&amp;", "&");
	}
	return newTitle;
}

/* Edit Source Modal */
function sourceEditModal(treeId, personId, sourceId, formId) {
	var url = getPersonAjaxUrlPrefix() + '/modals/sourceedit/tree/' + treeId + '/person/' + personId + '/sourceid/' + sourceId;
	$('<div>').modal({
		'showLoading': true,
		'useCustomPadding': true,
		'onOpen': function ($this) {
			$.ajax({
				type: 'GET',
				url: url,
				data: $('#FormSourceItem' + formId + ' :input').serialize(),
				cache: false,
				timeout: 20000,
				success: function (data) {
					$.modal.showLoading(false);
					$.modal.resize(760);
					/* Modal Data and Initialize Alerts */
					$this
						.html(data)
						.find('.modalTitle')
						.text(fixTitleText(window.SourceEditModal.title.sourceEditModaltitle))
						.end()
						.find('.alertNote')
						.alert(personViewModalAlertSettingsNote)
						.end()
						.find('.alertInfo')
						.alert(personViewModalAlertSettingsInfo)
						.end()
						.find('.alertSuccess')
						.alert(personViewModalAlertSettingsSuccess)
						.end()
						.find('.alert:not(.alertNote):not(.alertInfo):not(.alertSuccess)')
						.alert(personViewModalAlertSettingsWarning);
					/* Attaching Facts/Events to Source Citations */
					sortingCardOutlineHover();
					showModalAlerts(false, '#fact_sortingDivBottom', '#fact_sortingDivTop');
					$.cachedScript(PersonResearch.animateCardUrl).done(function () {
						sortCard('#fact_sortingDivBottom', '#fact_sortingDivTop');
					});
					/* Callouts for Source Edit modal */
					if (typeof (SourceEditModal) != 'undefined') {
						$this.on('click', '.removeButton', function () {
							var $removeButton = $(this);
							if (!$removeButton.data('calloutInstance')) {
								$removeButton.callout({
									'classes': 'calloutRemoveSource',
									'content': SourceEditModal.callouts.removeCitation,
									'position': 'top',
									'style': 'dark'
								});
								$removeButton.callout('open');
							}
						});
					}
					/* Open on load functionality could go to a different tab */
					var openTab = 0;
					if (typeof PersonResearch.openOnLoadTab != 'undefined') {
						openTab = parseInt(PersonResearch.openOnLoadTab);
					}
					/* If the media tab was requested, then load the media section */
					if (PersonResearch.tabName === 'Media') {
						sourceEditModalAttachedMedia(PersonResearch.treeId, PersonResearch.personId, sourceId);
						if (!SourceEditModal.hasRecord) {
							openTab = 2;
						} else {
							openTab = 3;
						}
					}
					else if (PersonResearch.tabName === 'details') {
						if (!SourceEditModal.hasRecord) {
							openTab = 0;
						} else {
							openTab = 1;
						}
					}
					/* Initiate Tabs */
					$('#modalContainer .tabs').tabs({
						'activeIndex': openTab
					});
					/* Associated Facts/Events */
					$('#sourceEditModalFacts').on('click', function () {
						sourceEditModalFacts();
					});
					/* Attached Media */
					$('#sourceEditModalAttachMedia').on('click', function () {
						sourceEditModalAttachedMedia(PersonResearch.treeId, PersonResearch.personId, sourceId);
					});
					/* PersonCard object is defined in Person.aspx */
					var femDefaultGlueOptions = (typeof (window.PersonCard) != 'undefined') ?
						{
							options: getTabData(window.PersonCard.tabName)
						} : {
							options: ''
						};

					/* Setup the URL of the initial rendered view */
					femUpdateURL(History.getState(), femDefaultGlueOptions.options);
				},
				failure: function () {
					$.modal.close();
				}
			});
			/* Temporary (TODO: Remove when global fix is on live.) */
			if (window.navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
				$('html').addClass('iOSFix');
			}
		},
		'$trigger': $('.factItemSelected')
	});
};
/* Modal Buttons */
function modalButtonClick() {
	$('.modalContents').on('click', '.tab', function () {
		/* Fact Edit Modal */
		if ($('#modal').hasClass('modalEditEvent')) {
			/* Preset display on life story */
			var displayLifeStory = $('.tabContent4').find('.displayLifestory'),
				displayLifeStoryVal = displayLifeStory.prop('checked');
			displayLifeStory.data('original-displaylifestory', displayLifeStoryVal.toString());
		}
	});
}
/* Update tab display */
function updateTabDisplay(selector) {
	var $tab = $('#' + selector + ''),
		$tabContent = $('.tabContent[aria-labelledby="' + selector + '"]');
	if ($tabContent.hasClass('loading')) {
		$tabContent
			.removeClass('loading')
			.removeAttr('aria-busy');
	} else {
		$tabContent
			.addClass('loading')
			.attr('aria-busy', 'true');
	}
}
/* Remove a person event */
function removePersonEvent(assertionid) {
	var url = getPersonAjaxUrlPrefix() + '/tree/' + PersonCard.treeId + '/person/' + PersonCard.personId + '/assertionid/' + assertionid + '/removepersonevent';
	$.ajax({
		type: 'POST',
		url: url,
		cache: false,
		timeout: 20000,
		success: function (data) {
			if (data.status) {
				if (window.glue) {
					var eventType = FactEditModal.eventType;
					if (eventType.toString() === 'Birth' || eventType.toString() === 'Death') {
						if (PersonCard.isFamilySearchUser) {
							location.reload();
						} else {
							var $assertion = $('#fi' + assertionid);
							if (($assertion.hasClass('preferredEventBirth') || $assertion.hasClass('preferredEventDeath')) || $('.pageHeader').hasClass('pageHeaderStory')) {
								window.getPersonCard();
							}
							window.glue.reload();
						}
					} else {
						window.glue.reload();
					}
				} else {
					location.reload();
				}
				closeCallouts();
				$.modal.close();
			}
		}
	});
}
/* Show Modal Alerts */
function showModalAlerts(hasError, sortBottom, sortTop) {
	var $sortTop = $(sortTop),
		$sortBottom = $(sortBottom);
	if (hasError) {
		$sortTop
			.find('.alert:not(.alertInfo)')
			.alert('open');
		$sortBottom
			.find('.alert:not(.alertInfo)')
			.alert('open');
	} else {
		if ($sortTop.find('.card').length === 0) {
			$sortTop
				.find('.alertInfo')
				.alert('open');
		}
		if ($sortBottom.find('.card').length === 0) {
			$sortBottom
				.find('.alertInfo')
				.alert('open');
		}
	}
}
